/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'マイ動画ショート',
    see_more: 'もっと見る',
    no_shorts_found: 'ショート動画が見つかりません',
    shorts: 'ショート',
    general_information: '一般情報',
    gamification: 'ゲーミフィケーション',
    click_to_select_files: 'ファイルを選択するにはクリック',
    selected_files: '選択されたファイル',
    uploaded: 'アップロード済み',
    failed: '失敗',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'システムは自動的に分析し、コンテンツ要件に基づいて組織のライブラリから最も関連性の高いドキュメントを選択します。',
    select_from_library: ' ライブラリから選択',
    search_document: 'ドキュメントを検索...',
    selected: '選択済み',
    loading_documents: 'ドキュメントを読み込み中...',
    review_generated_content: '生成されたコンテンツを確認',
    confirm_and_replace_content: 'コンテンツを確認して置き換える',
    the_generate_content_will_replace:
      '生成されたコンテンツは選択したページの既存のテキストを置き換えます。変更を適用したくない場合は、前のステップに戻ることができます。',
    pages_to_be_updated: '更新されるページ',
    generated_revisions: '生成された修正',
    lesson_preview: 'レッスンプレビュー',
    create_new_folder: '新しいフォルダを作成',
    rename_item: 'アイテムの名前を変更',
    enter_folder_name: 'フォルダ名を入力:',
    enter_new_name: '新しい名前を入力:',
    folder_name: 'フォルダ名:',
    new_name: '新しい名前',
    move_items: 'アイテムを移動',
    copy_items: 'アイテムをコピー',
    move_here: 'ここに移動',
    copy_here: 'ここにコピー',
    select_destination_library_and_folder: '宛先ライブラリとフォルダを選択:',
    items_selected: '選択されたアイテム',
    version: 'バージョン',
    modified_by: '変更者',
    size: 'サイズ',
    restore: '復元',
    are_you_sure_you_want_to_restore_this_version:
      'このバージョンを復元してもよろしいですか？',
    this_will_replce_the_current_version_with_the_selected_one:
      '現在のバージョンは選択したものに置き換えられます。',
    restore_this_version: 'このバージョンを復元',
    restore_not_available: '復元不可',
    version_history: 'バージョン履歴:',
    by_making_items_public:
      'アイテムを公開すると、誰でも閲覧可能になります。続行する前に利用規約を確認してください。',
    the_selected_items_will_be_copied:
      '選択したアイテムは公開ライブラリにコピーされ、すべての人が閲覧できます。',
    the_selected_items_will_be_copied_to_org:
      '選択したアイテムは組織ライブラリにコピーされ、すべての組織メンバーが閲覧できます。',
    the_selected_items_will_be_copied_to_your_private:
      '選択したアイテムはプライベートライブラリにコピーされ、あなたのみが閲覧できます。',
    loading_organization: '組織のユーザーを読み込み中...',
    click_download_to_view: '表示するにはダウンロードをクリック',
    archive_file: 'アーカイブファイル',
    no_preview_available: 'プレビューは利用できません',
    audit_report: '監査レポート',
    audit_type: 'アクションタイプ',
    i_agree_to_the_terms_and_conditions: '利用規約に同意します。',
    this_file_is_indexed_for_ai:
      'このファイルはAI用にインデックスされています。',
    file_is_not_indexed_for_ai:
      'このファイルはAI用にインデックスされていません。',
    no_users_found: 'ユーザーが見つかりません',
    no_users_available: '利用可能なユーザーはいません',
    add_people: 'ユーザーを追加',
    people: 'ユーザー',
    access_type: 'アクセス権タイプ',
    no_group_found: 'グループが見つかりません',
    add_group: 'グループを追加',
    groups: 'グループ',
    users_top: 'ユーザー',
    confirm_delete: '削除を確認',
    do_you_want_remove: '本当に削除しますか？',
    form_this_documents_permissions: 'このドキュメントの権限から？',
    no_users_found_in_this_group: 'このグループにユーザーが見つかりません',
    add_selected_users: '選択したユーザーを追加',
    choose_users_from_the_list: 'リストからユーザーを選択',
    selected_users: '選択されたユーザー',
    archived: 'アーカイブ済み',
    request_approval: '承認をリクエスト',
    document_in_review: 'ドキュメントレビュー中',
    approve: '承認',
    reject: '拒否',
    comment: 'コメント:',
    enter_your_commit: 'コメントを入力...',
    confirm_cancel: 'キャンセルを確認',
    upload_3d_zip: '3D ZIPをアップロード',
    delete_items: 'アイテムを削除',
    video_upload_request: 'ビデオアップロードリクエスト',
    reject_video: 'ビデオを拒否',
    enter_rejection_reason: '拒否理由を入力...',
    please_provide_a_reason_for_reejection_this_video:
      'このビデオを拒否する理由を入力してください:',
    generate_trivia_with_ai: 'AIでトリビアを生成',
    select_category: 'カテゴリを選択:',
    number_of_question: '質問数',
    generated_questions: '生成された質問',
    this_will_clear_all_generate_question:
      'これにより、生成されたすべての質問がクリアされます。続行しますか？',
    sure_delete: '本当に削除しますか？',
    delete_this_question: '本当にこの質問を削除しますか？',
    loading_quiz: 'クイズを読み込み中...',
    creteing_file: 'ファイル作成中',
    opening_desktop_app: 'デスクトップアプリを開いています...',
    this_folder_is_empty: 'このフォルダは空です',
    select_a_competition: 'コンペティションを選択...',
    activity_badges: 'アクティビティバッジ',
    awarded_every_badges: '4, 8, 16, 32, 64, 128, 256, 512回ログインごとに付与',
    learning_badges: '学習バッジ',
    awarded_every_courses: '1, 4, 8, 16, 32, 64, 128回の完了コースごとに付与',
    test_badges: 'テストバッジ',
    awarded_every_passes_tests:
      '2, 4, 8, 16, 32, 64, 128, 256回の合格テストごとに付与',
    assignment_badges: '課題バッジ',
    awarded_every_passed_assignments:
      '1, 2, 4, 8, 16, 32, 64, 128回の課題合格ごとに付与',
    perfectionism_badges: '完璧主義バッジ',
    awarded_every_assignments_with_scrore:
      'スコア90%以上のテストまたは課題ごとに付与',
    communication_badges: 'コミュニケーションバッジ',
    awarded_every_topics_or_comments:
      '2, 4, 8, 16, 32, 64, 128, 256回のトピックまたはコメントごとに付与',
    certification_badges: '認定バッジ',
    awarded_every_certificates:
      '1, 2, 4, 8, 16, 32, 64, 128回の認定書ごとに付与',
    level_name: 'レベル名',
    delete_competition: 'コンペティションを削除',
    this_week: '今週',
    this_year: '今年',
    make_organization: '組織化する',
    no_results_found: '結果が見つかりません',
    no_items_available: 'アイテムがありません',
    help_video: 'ヘルプビデオ',
    select_a_video_from_the_list: '学習を開始するにはリストからビデオを選択'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'ファイルをドロップしてアップロード先を選択してください。',
    duplicate_lessoon: 'このレッスンはすでにコースに存在します',
    skill_rule_title: 'スキルジャーニータイトルを入力してください',
    imageCreatorTitle: 'イメージクリエイター',
    isTranslated: '翻訳済み',
    translationCourseDesc:
      'このコースの翻訳には数分かかる場合があります。ご理解ありがとうございます！',
    translateCourseTip:
      '元のコースとは独立して編集できる翻訳コースを作成します。すべてのレッスンとページが含まれます。',
    translateModalBtn: '翻訳する',
    translationSuccess: 'コース「<0/>」の翻訳が成功しました！',
    translatingCourse: 'コースを翻訳中...',
    translateModalTitle: 'コースを翻訳する',
    translateSelectLang: '言語を選択',
    fileDeleteconfirm:
      'このファイルを削除してもよろしいですか？この操作は元に戻せません。',
    fileDeleteMessage: 'ファイルが正常に削除されました。',
    fileDeleteFailedMessage: 'ファイルの削除に失敗しました！',
    fileDelete: 'このファイルを削除する。',
    certificate_save_btn: '証明書を追加する',
    maze_path_info: 'グラフに利用可能なパスがありません！',
    file_size_mb: 'ファイルサイズは25MB未満でなければなりません！',
    reports: {
      products: '製品',
      users: 'ユーザー',
      ph_username: 'ユーザー名で検索',
      ph_id: 'ユーザーID番号で検索',
      ph_email: 'ユーザーのメールで検索'
    },
    select_upload_section_id: 'ファイルセクションは必須です',
    tags_all: 'すべて',
    delete_file_confirm: 'このファイルを削除してもよろしいですか？',
    delete_file_title: 'ファイルを削除',
    tooltip_publish: '選択したオプションでコースを公開する',
    tooltip_save: '現在の更新内容でコースを保存する',
    tooltip_next: '次のコース設定へ進む',
    tooltip_finish: '現在の更新を完了して保存する',
    stories_modal: {
      title_upload: 'ストーリーをアップロード',
      title_update: 'ストーリーを更新',
      title_audio: 'ストーリーの音声ファイル',
      btn_upload: 'アップロード',
      btn_update: '更新',
      btn_close: '閉じる',
      btn_cancel: 'キャンセル',
      lbl_cover: 'ストーリーカバー画像',
      rule_cover: 'ストーリーの音声カバーをアップロードしてください！',
      lbl_title: 'ストーリー音声タイトル',
      rule_title: 'ストーリー音声のタイトルを入力してください！',
      lbl_description: 'ストーリー音声の説明',
      rule_description: 'ストーリー音声の説明を入力してください！',
      lbl_file: 'ストーリー音声ファイルをアップロード',
      rule_file: 'ストーリー音声ファイルをアップロードしてください！',
      rule_file_type:
        '有効なストーリー音声ファイルをアップロードしてください！',
      lbl_select_file: 'ストーリー音声ファイルを選択',
      msg_valid_file: '有効なストーリー音声ファイルを選択してください！',
      msg_success: 'ストーリー音声ファイルが正常にアップロードされました',
      msg_failed: 'メディアデータの割り当てに失敗しました！',
      msg_error: 'ファイルのアップロード中にエラーが発生しました！'
    },
    audio_modal: {
      title_upload: 'アップロード',
      title_update: '更新',
      title_audio: '音声ファイル',
      btn_upload: 'アップロード',
      btn_update: '更新',
      btn_close: '閉じる',
      btn_cancel: 'キャンセル',
      lbl_cover: '音声カバー',
      rule_cover: '音声カバーをアップロードしてください！',
      lbl_title: '音声タイトル',
      rule_title: '音声タイトルを入力してください！',
      lbl_description: '音声説明',
      rule_description: '音声説明を入力してください！',
      lbl_file: '音声ファイルをアップロード',
      rule_file: '音声ファイルをアップロードしてください！',
      rule_file_type: '有効な音声ファイルをアップロードしてください！',
      lbl_select_file: '音声ファイルを選択',
      msg_valid_file: '有効な音声ファイルを選択してください！',
      msg_success: '音声ファイルが正常にアップロードされました',
      msg_failed: 'メディアデータの割り当てに失敗しました！',
      msg_error: 'ファイルのアップロード中にエラーが発生しました！'
    },
    info_episode: 'エピソードのカバー画像。',
    btn_delete_episode: 'このポッドキャストエピソードを削除する。',
    btn_edit_marketplace: 'マーケットプレイスの詳細を編集する。',
    btn_save_marketplace: '現在の変更を保存する。',
    btn_ai_podcast: 'AI搭載のポッドキャストエピソードを作成する。',
    btn_upload_podcast:
      '自分のポッドキャスト音声エピソードをアップロードする。',
    attach_file:
      'ファイルをアップロードして、より多くのコンテンツをオーディエンスと共有する',
    fileDownload: 'このファイルをダウンロードする。',
    singleEpishode: 'エピソード',
    podcast_music: 'ポッドキャスト、音楽＆ストーリー',
    publishHeader: 'ポッドキャスト、音楽＆ストーリーを公開する',
    editHeader: 'ポッドキャスト、音楽＆ストーリーを編集する',
    createHeader: 'ポッドキャスト、音楽＆ストーリーを作成する',
    marketplaceHeader:
      'ポッドキャスト、音楽＆ストーリーマーケットプレイスの詳細',
    message_marketplace: 'マーケットプレイスフォームを完成させてください！',
    create_podcast_live: 'ライブポッドキャストと音楽',
    create_podcast_custom: 'カスタムポッドキャストと音楽',
    create_podcast_stories: 'ストーリー',
    ai_Assisted_podcast_reation: 'AI支援のポッドキャストと音楽',
    publishTitle:
      'ポッドキャスト、音楽＆ストーリーを公開して一般に表示します。',
    customButton: 'カスタム作成',
    customTitle: 'ポッドキャストに加えた変更を保存します。',
    updateButton: '更新',
    createButton: '作成',
    createNewButton: '新規作成',
    updateTitle: '現在のポッドキャスト、音楽＆ストーリーの詳細を更新します。',
    createTitle: '新しいポッドキャスト、音楽＆ストーリーを作成します。',
    createNewTitle:
      '現在のポッドキャスト、音楽＆ストーリーに新しい入力内容で新しいポッドキャスト、音楽＆ストーリーが作成されます。',
    podcastTitle: 'エピソード一覧',
    podcastStoryTitle: 'ストーリーエピソード一覧',
    podcastToolTipTitle: 'ポッドキャストエピソードの一覧',
    uploadAudio: 'アップロード',
    aiAudio: 'AI音声',
    emptyPodcast:
      'まだポッドキャスト、音楽＆ストーリーの音声録音はありません。',
    emptyStoriesPodcast: 'まだストーリーは追加されていません。',
    emptyCreatePodcast:
      '音声を追加するには、ポッドキャストを作成してください。',
    playPodcast: '選択したポッドキャスト、音楽＆ストーリーを再生します。',
    pausePodcast: '選択したポッドキャスト、音楽＆ストーリーを一時停止します。',
    selectPodcast: 'このポッドキャスト、音楽＆ストーリーを選択します。',
    downloadPodcast: 'この音声をダウンロードします。',
    uploadAudioFile: '新しい音声をアップロードして現在の音声と置き換えます。',
    deleteConfirm: 'この音声を削除してもよろしいですか？',
    roomName: 'ポッドキャスト名',
    addGuestTitle: 'ゲストスピーカーを追加',
    showTime: '表示時間',
    startTime: '開始時間',
    endTime: '終了時間',
    erorMsgImg: '有効な画像を選択してください。',
    failedMsgImg: '画像の読み込みに失敗しました。再試行してください！',
    failedMsgUpload: 'カバー画像のアップロードに失敗しました！',
    btnCoverUpload: 'カバーをアップロード',
    is_private: '非公開',
    to_attach: 'ファイルを添付',
    file_attached: '添付ファイル',
    main_event: 'メインイベント',
    event: 'イベント',
    upload_pdf: 'PDFをアップロード',
    portrait: '縦向き',
    landscape: '横向き',
    import_from_library: 'メディアライブラリからテキストをインポート',
    question_answer_ai: '質問/回答AI',
    take_maze: 'MetaMazeを受ける',
    training: 'トレーニング',
    select_transcribe_locale: '文字起こし言語を選択',
    transcribe_limit: '文字起こし分数を入力してください',
    not_complete: 'マーケットプレイス情報が未完成です',
    complete: 'マーケットプレイス情報が完成しています',
    not_admin: 'マーケットプレイスに公開するには管理者権限が必要です',
    no_course:
      'タイトルを入力し、マーケットプレイスを有効にするために画像を選択してください',
    scorm_not_complete:
      'SCORMファイルをアップロードするには、タイトルを入力し、画像を選択してください',
    not_found_maze: 'MetaMazeが見つかりません',
    email_require: 'メールが必要です',
    poll_required: 'アンケートデータが必要です',
    alert: '警告！',
    warning: '注意！',
    ok: 'OK',
    cancel: 'キャンセル',
    done: '完了',
    insert: '挿入',
    private: '非公開',
    public: '公開',
    no_connection: 'インターネット接続が失われました',
    switch: '切り替え',
    share_screen: '画面を共有',
    stop_share_screen: '画面共有を停止',
    share_screen_with_camera: 'カメラ付き画面共有',
    stop_share_screen_with_camera: 'カメラ付き画面共有を停止',
    camera_on: 'カメラオン',
    camera_off: 'カメラオフ',
    mic_on: 'ミュート解除',
    mic_off: 'ミュート',
    fullscreen: '全画面表示',
    live_now: 'ライブ中',
    schedule_on: '予定日時',
    organisations: '組織',
    org_groups: '組織グループ',
    specific_user: '特定ユーザー',
    gif: 'GIF',
    unavailable: '利用不可',
    yes: 'はい',
    no: 'いいえ',
    event_duration_message: '最大300分（5時間）',
    send_email: 'メール通知を送信',
    admin_only: '管理者のみ',
    join: '参加',
    leave: '退出',
    share: '共有',
    share_text:
      'このファイルを共有したい相手のメールアドレスを入力してください。',
    share_text_title: 'PDFを共有',
    share_text_title_txt: 'テキストを共有',
    select_users: 'ユーザーを選択',
    delete: '削除',
    attachment_event: 'イベントの添付ファイル:',
    transcribe_limit: '文字起こし分数',
    monthly_transcribe: '月間文字起こし制限:',
    enable_ai: 'AIを有効にする:',
    enable_maze: 'MetaMazeを有効にする:',
    media_service: 'メディアサービス',
    allow_others: '他者の編集を許可',
    join_breakout_room: 'ブレイクアウトルームに参加',
    bio: 'プロフィール',
    linkedin: 'LinkedIn',
    select_org_report: 'レポートを作成する組織を選択してください。',
    org_image_not_found: '画像が見つかりません',
    insert_text: 'テキストを挿入',
    insert_question_answer: '質問/回答AI',
    modal_title2: 'テキストギャラリー',
    my_text_library: 'マイテキストライブラリ',
    ai: 'AI',
    public_text_library: '公開テキストライブラリ',
    organization_text_library: '組織テキストライブラリ',
    no_transcribed_text: '文字起こしテキストが見つかりません',
    public_text_not_found: '公開文字起こしテキストが見つかりません',
    org_text_not_found: '組織文字起こしテキストが見つかりません',
    org_video_not_found: 'ビデオが見つかりません',
    canva: 'Canvaで作成',
    canva_open: 'Canvaエディタを開くにはここをクリックしてください。',
    pdf: 'PDF',
    txt: 'テキスト',
    human: 'プレミアム',
    shared_file: 'ファイルが正常に共有されました。',
    error_shared_file: 'ファイルの共有に問題があります。再試行してください。',
    publish: '公開',
    maze_scenes: 'MetaMazeシーン',
    pexel_images: 'Pexel画像',
    group: 'グループ',
    group_name: 'グループ名',
    select_group: 'グループを選択',
    search_maze: 'メタメイズを検索',
    hosts: 'ホスト',
    avg_score: '平均スコア（％）',
    maze_report: 'メタメイズレポート',
    maze_view: 'メタメイズビュー',
    title_maze: 'メタメイズ',
    author: '作成者',
    match: 'ルート一致',
    preview_mazeTitle: 'タイトル：',
    other: 'その他',
    total: '合計',
    report_course: 'コース',
    report_courses: 'コース一覧',
    report_event: 'イベント',
    report_events: 'イベント一覧',
    report_maze: 'メタメイズ',
    report_personalize_learning: 'パーソナライズ学習',
    report_live_assessment: 'ライブアセスメント',
    report_live_assessments: 'ライブアセスメント一覧',
    report_skill_journey: 'スキルジャーニー',
    skill_journey: 'スキルジャーニー',
    skill_journeys: 'スキルジャーニー一覧',
    date: '日付：',
    search_people: 'ユーザー検索',
    passed: '合格',
    failed: '不合格',
    item: 'アイテム',
    type: 'タイプ',
    minimum_pass_score: '合格最低スコア',
    resources_count: 'リソース数',
    back: '戻る',
    resources: 'リソース',
    time_spent: '所要時間（分）',
    detail: '詳細',
    watched_time_mins: '視聴時間（分）',
    personalize_learning: 'パーソナライズ学習',
    result: '結果',
    assessment_title: 'タイトル',
    marketPlace_graph: 'マーケットプレイスグラフ',
    attachments: '添付ファイル',
    new_scorm_course: '新しいSCORMコースをアップロード',
    upload_scorm_course: 'SCORMコースをアップロード',
    new_maze: '新しいメタメイズを作成',
    new_skill_journey: '新しいスキルジャーニーを作成',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'スキルジャーニー',
    new_discussion_room: '新しいポッドキャストを作成',
    title: '今日は何をしますか？',
    build_course: 'コースを作成',
    live_broadcast: 'ライブ配信',
    invite_users: '組織にユーザーを招待',
    build_voice_over: '音声ナレーションを作成',
    view_reports: 'レポートを見る',
    upload_media: 'メディアや作品をアップロードして共有',
    main_menu: 'メインメニュー',
    get_started: '始める',
    search_group: '組織グループを検索',
    ai_course: 'AIコース',
    search_user: '会社名を検索',
    no_maze: '現在、MetaMazeはありません。',
    conference_event_title: 'カンファレンスイベント',
    conference_event_subTitle: '終了したカンファレンス',
    conference_event: '現在、カンファレンスイベントはありません。',
    no_skill: '現在、スキルジャーニーはありません。',
    no_podcast: '現在、ポッドキャストはありません。',
    maze_channel: 'メタメイズ',
    past_live_assessment: '過去のライブアセスメント',
    no_live_assessment: '現在、ライブアセスメントはありません。',
    enrolled_courses: '登録済みコース',
    my_video_channel: 'マイビデオチャンネル',
    enrolled_liveEvents: '登録済みライブイベント',
    sharebot: 'シェアボット',
    selected_language: '選択中の言語',
    shareSphere_game: 'ShareSphereゲーム',
    maze: 'メタメイズ',
    skill: 'スキルジャーニー',
    channel: 'チャンネル',
    order: '順序',
    is_record: '記録中',
    no_maze_found: 'MetaMazeが見つかりません。',
    maze_self_limit_reached: 'MetaMazeの自己アセスメント回数上限に達しました。',
    metamaze_two_times: 'このMetaMazeは既に2回完了しています。',
    metamaze_two_times_no_result:
      'このMetaMazeは既に2回完了しています。2回目以降は結果が記録されません。',
    scorm_zip: 'SCORM ZIP',
    pass_score: '合格最低点',
    organization: '組織を選択してください',
    pass_score_mark: '1～100の間でスコアを入力してください',
    maze_cloning_success: 'MetaMaze “<0/>” のクローンが正常に完了しました！',
    create_certificate: '証明書を作成',
    create_badge: 'バッジを作成',
    certificate_added: '証明書が追加されました。',
    badge_added: 'バッジが追加されました。',
    certificate_warning: '証明書／バッジが公開されたら編集できません！',
    created_course_plan:
      '作成したコースとライブイベントを編集して公開してください',
    market_place_space: 'マーケットプレイス',
    select_course_language: '言語を選択（任意）',
    select_language: '言語を選択',
    file_upload: 'ファイルをアップロード',
    text: 'ここにテキストを入力…',
    attempts_count: 'ユーザーが再挑戦できる回数',
    no_of_people_placeholder: '人数',
    back_to_maze: 'MetaMazeシナリオに戻る',
    edit_maze: 'MetaMazeを編集',
    wait: 'お待ちください…',
    retry: '再試行',
    publish_scorm_course: 'SCORMコースを公開',
    publish_maze: 'MetaMazeを公開',
    import: '要素をインポート',
    answer_correct: '正しい答えを選んでください',
    author_name: `著者名を入力してください`,
    select_category: 'カテゴリを選択してください',
    course_outline: 'コース概要を入力してください',
    course_obj: 'コースの目的を入力してください',
    course_description: 'コース説明を入力してください',
    maze_outline: '迷路の概要を入力してください',
    maze_obj: '迷路の目的を入力してください',
    maze_description: '迷路の説明を入力してください',
    lessons: 'レッスン数を入力してください',
    user_email_require: `ユーザーのメールアドレスは必須です`,
    team_size: `チームサイズは必須です`,
    enter_price: '価格を入力してください（5以上）',
    input_title_maze: '迷路のタイトルを入力してください',
    trainer_bio: 'トレーナーのプロフィールを入力してください',
    trainer_linkedin: 'トレーナーのLinkedInを入力してください',
    error_video: 'ビデオの数を入力してください',
    input_video_link: 'ビデオリンクを入力してください',
    number_of_video: 'ビデオの数',
    number_of_lessions: 'レッスン数',
    no_of_people_in_conference: '会議の参加人数は？',
    transcribe_settings: '文字起こし設定',
    transcribe: '文字起こし',
    cloning_maze: 'メタ迷路をクローン中...',
    id_number: 'ID番号',
    timezone: 'タイムゾーン',
    edit_maze: '編集',
    delete_maze: '削除',
    view_maze: '表示',
    create_metamaze: 'メタ迷路を作成',
    metamaze_scenario: 'メタ迷路のシナリオ',
    publish_metamaze: '公開設定',
    search_result: '検索結果：',
    search_for: '検索する',
    search_no_result: '- 結果がありません！',
    channel_no_available: '利用可能なチャンネルがありません！',
    this_card: 'これはカードです',
    course_no_available: '利用可能なコースがありません！',

    exit_fullscreen: 'フルスクリーンを終了',
    bg_image: '背景画像',
    introduction: '導入',
    summary: '要約',
    generate_introduction: '導入を生成',
    generate_summary: '要約を生成',
    bullet_points: '箇条書き',
    title_simulation: 'シミュレーション名を入力してください',
    view_generated_images: '生成された画像を見る',
    image_transparency: '画像の透明度',
    template_bg_color: 'テンプレートの背景色',
    select_template_layout: 'テンプレートレイアウトを選択',
    reload_template: '(テンプレートを再読み込み)',
    are_you_sure_want_close: '閉じてもよろしいですか？',
    all_your_changes_will_be_lost: 'すべての変更が失われます。',
    please_checked_before_generated_video:
      'ビデオ生成前にすべての条件を確認してください。',
    voice_must_be_selected: '音声を選択してください',
    avatar_must_be_selected: 'アバター画像を選択してください。',
    maximum_five_slides_try_again:
      'ファイルから画像を抽出中にエラーが発生しました。ファイルには最大5枚のスライドがあり、各スライドにノートがあることを確認してください。再試行してください！',
    back_to_upload: 'アップロードに戻る',
    uploading_file_to_server: 'ファイルをサーバーにアップロード中',
    extracting_images_from_your_file: 'ファイルから画像を抽出中',
    upload_your_ppt_or_drag:
      'プレゼンテーションファイル（.PPTX）をアップロードするか、ここにドラッグしてください。',
    maximum_five_slides_error:
      'PowerPointファイルには最大5枚のスライドがあり、各スライドにノートがあることを確認してください。さもないとエラーになります。',
    number_of_questions_generated: '生成する質問の数',
    quiz_page_this_cannot_be_done:
      'このページにクイズを追加してもよろしいですか？元に戻せません。',
    confirm_selection: '選択を確認',
    select_quiz_page: 'クイズページを選択',
    lesson_do_you_want_add_this_quiz:
      'どの部分のレッスンにこのクイズを追加しますか？',
    beginning_of_lesson: 'レッスンの最初に',
    end_of_lesson: 'レッスンの最後に',
    currently_active_page: '現在のアクティブページ',
    finish: '終了',
    upload_selection_file: 'セクションファイルをアップロード',
    general_quiz: '一般クイズ',
    manage_sequence: 'シーケンスを管理',
    save_sequence: 'シーケンスを保存',
    new: '新規',
    in_progress: '進行中',
    recommended_course: 'おすすめコース',
    up_coming: '今後の予定',
    past_live: '過去のライブ',
    input_your_channel_name: 'チャンネル名を入力してください！',
    organization_place: '組織マーケットプレイス',
    marketplace_report: 'マーケットプレイスレポート',
    story_writing: '物語作成',
    Ai_quiz: 'AIクイズ',
    generate_quiz: 'クイズを生成',
    create_story: '物語を作成',
    change_layout_page: 'ページのレイアウトを変更しようとしています。',
    change_layout_message:
      'テキスト、画像、背景、ロゴのみが保持されます。その他の要素はすべてページから削除されます。',
    reviews: 'レビュー',
    tab_attachments: '添付ファイル',
    zoom_in: 'ズームイン',
    zoom_out: 'ズームアウト',
    zoom_reset: 'ズームリセット',
    no_attachment: '添付ファイルなし。',
    select_upload_simulation:
      'シミュレーションを選択/アップロードしてください。',
    quiz_updated_successfully: 'クイズが正常に更新されました！',
    quizes: 'クイズ',
    trivia: 'トリビア',
    closing: '閉じています...',
    products: '製品',
    ask_questions: 'ここで質問してください...',
    course_information: 'コース情報',
    course_assistance: 'コース作成支援',
    go_back: '戻る',
    ai_generate_content_progress: 'コンテンツ生成進行中',
    view_generate_content: '生成されたコンテンツを見る',
    generate_error: '生成エラー！',
    confirm_creating_course: 'この内容でコースを作成してよろしいですか？',
    generate_content_automatically:
      '生成されたすべての内容が自動的にレッスンとページとしてコースに追加されます。',
    quiz_created_successfully: 'クイズが正常に作成されました！',
    create_quiz: 'クイズを作成',
    quiz_setting: 'クイズ設定',
    please_fill_quiz_setting: '* クイズ設定のすべての項目を入力してください',
    question_list: '質問リスト',
    add_quiz_to_page: 'クイズをページに追加',
    form_create_question: '質問作成フォーム',
    user_information_updated: 'ユーザー情報が更新されました！',
    your_stripe_activete_to_continue:
      'Stripeアカウントが無効です。続行するには接続または有効化してください。',
    connect_tripe: 'Stripeに接続',
    certificate_sent_sucessfully: '証明書がメールに正常に送信されました。',
    error_try_again: 'エラー。もう一度試してください！',
    error_delete_channel: 'チャンネルの削除中にエラーが発生しました。',
    error_update_sub: 'サブスクリプションの更新中にエラーが発生しました。',
    end_time_cannot_start: '終了時間は開始時間より前にできません。',
    start_date_time_interval: '開始日時の間隔が必要です！',
    podcast_updated_successful: 'ポッドキャストが正常に更新されました。',
    podcast_created_successful: 'ポッドキャストが正常に作成されました。',
    podcast_published_successful: 'ポッドキャストが正常に公開されました',
    podcast_cover_updated: 'ポッドキャストのカバーが更新されました',
    new_podcast_details: '新しい入力内容で現在のポッドキャストを作成します。',
    current_update_podcast:
      '現在のポッドキャスト、音楽＆ストーリー詳細を更新します。',
    create_new_podcast: '新しいポッドキャストを作成',
    publish_podcast_public_view: '公開用にポッドキャストを公開します。',
    only_allowed_twenty_five_email: 'メールは25件まで許可されています',
    only_allowed_five_email: 'メールは5件まで許可されています。',
    cover_is_required: 'カバーは必須です。',
    topic_is_required: 'トピックは必須です。',
    delete_schedule: 'スケジュールを削除',
    make_as_coaching: 'コーチング利用可能に設定',
    manage_category: 'カテゴリを管理',
    threshold: 'しきい値',
    threshold_popup: 'しきい値（%）で、指定カテゴリの推薦が有効になる値。',
    list_of_catagory: 'カテゴリ一覧',
    category_name: 'カテゴリ名',
    category_threshold: 'カテゴリのしきい値',
    play_game: 'ゲームをプレイ',
    switching_organization: '組織を切り替えています...',
    coaching_session: 'コーチングセッション',
    required_channel_id: 'チャンネルIDは必須です！',
    error_occured_try_again: 'エラーが発生しました。もう一度試してください！',
    please_complete_marketplace_form:
      'マーケットプレイスフォームを完成させてください！',
    upload_file_corrupt: 'アップロードされたファイルが壊れています。',
    course_not_published: 'コースはまだ公開されていません！',
    error_request: 'リクエストエラー。もう一度試してください！',
    skill_request: '不足している項目を完成させてください！',
    error_occured: 'エラーが発生しました。もう一度試してください！',
    show_time: '表示時間',
    start_time: '開始時間',
    end_time: '終了時間',
    room_name: 'ポッドキャスト名',
    add_guest_speaker: 'ゲストスピーカーを追加',
    cover_picture: 'カバーピクチャ',
    guest_speaker: 'ゲストスピーカー',
    see_more: 'もっと見る',
    see_less: '閉じる',
    background: '背景',
    icon: 'アイコン',
    icon_size: 'アイコンサイズ',
    icon_color: 'アイコンカラー',
    only_text: 'テキストのみ',
    change_bg: '背景色を変更',
    bg_color: '背景色',
    font_size: 'フォントサイズ',
    normal: '標準',
    change_color: 'テキスト色を変更',
    slant_text: '斜体テキスト',
    text_radius: 'テキスト半径',
    vertical_align: '垂直揃え',
    horizontal_align: '水平揃え',
    change_icon_color: 'アイコン色を変更',
    upload_icon: 'アイコンをアップロード',
    upload_signature: '署名をアップロード',
    add_another_sign: '別の署名を追加',
    name_badges: 'バッジ名',
    should_less_150: '150文字以内で入力してください',
    your_badge: 'あなたのバッジ',
    do_you_want_delete_badge: 'このバッジを削除してもよろしいですか？',
    do_you_want_delete_cert: 'この証明書を削除してもよろしいですか？',
    upload_logo: 'ロゴをアップロード',
    name_of_cert: '証明書名',
    upload_cert: '証明書を更新',
    your_cert: 'あなたの証明書',
    translate_to: '翻訳先',
    select_file_attach: '添付ファイルを選択',
    certificate: '証明書',
    badge: 'バッジ',
    publish_options: '公開オプション',
    publish_skills_journey: 'スキルジャーニーを公開',
    videos: 'ビデオ',
    generate_ai_video:
      'ビデオ生成には時間がかかる場合があります。完了後にメールで通知されます。',
    trainer_information: 'トレーナー情報',
    promotional_video_link: 'プロモーションビデオリンク',
    please_select: '選択してください',
    image_name: '画像名：',
    image_size: '画像サイズ：',
    charecters_fifteen_less: '15文字以内',
    leadership: 'リーダーシップ',
    text_arc: 'テキストアーク',
    vertical: '垂直',
    horizontal: '水平',
    badge_history: 'バッジ履歴',
    templates: 'テンプレート',
    sign: '署名',
    logo: 'ロゴ',
    certificate_history: '証明書履歴',
    please_wait: 'お待ちください...',
    information: '情報',
    support_five_thousand_live_event: 'イベント参加者最大5000人をサポート',
    support_ten_live_event: 'ライブビデオ参加者最大10人をサポート',
    we_will_back_participant: '大量の参加者を収容できるイベントに戻ります。',
    course_objectives: 'コースの目的',
    course_outlines: 'コース概要',
    price_dollor: '価格 (USD)',
    not_completed: '未完了',
    enable_marketplace: 'マーケットプレイスを有効にする',
    enable_course_ai: 'AIコース作成を有効にする',
    enable_report_to_admin: '管理者への報告を有効にする',
    enable_white_label: 'ホワイトラベルを有効にする',
    enable_eleven_labs_for_maze_play: 'Maze プレイに ElevenLabs を有効にする',
    enable_eleven_labs_for_maze_play_cloned:
      'クローン音声に ElevenLabs を有効にする',
    simulation_quiz: 'シミュレーションクイズ',
    bg_color_setting: '背景色設定',
    color_preview: '色のプレビュー',
    choose_new_color: '新しい色を選択',
    remove_color: '色を削除',
    apply_color: '色を適用',
    elemeent_in_a_sceenario_page:
      'このシナリオページにはこれ以上要素を追加できません。別のページを試すか既存の要素を削除してください。',
    no_data_found: 'データが見つかりません',
    references: '参考文献',
    open_file: 'ファイルを開く',
    showing_result: '結果の表示:',
    fiften_day_free_trail: '15日間の無料トライアル',
    your_browser_does_not_support:
      'お使いのブラウザはオーディオをサポートしていません。',
    podcast_desc: 'ポッドキャストの説明',
    input_podcast_desc: 'ポッドキャストの説明を入力してください',
    podcast_obj: 'ポッドキャストの目的',
    input_podcast_obj: 'ポッドキャストの目的を入力してください',
    podcast_outline: 'ポッドキャストのアウトライン',
    input_podcast_outline: 'ポッドキャストのアウトラインを入力してください',
    add_file: 'ファイルを追加',
    generate_podcast_audio: 'ポッドキャスト音声を生成',
    generate_uploaded_file_input_parameter:
      'アップロードしたファイルの内容に基づいて生成されます。',
    go_backe_generation_state: '生成状態に戻る',
    create_ai_powered_podcast: 'AIでポッドキャストを作成',
    generate_voice_for_all_podcast: 'すべてのエピソードに音声を生成',
    create_podcast_episode: 'ポッドキャストエピソードを作成',
    voice_name: '音声名',
    input_custom_name: 'カスタム名を入力してください！',
    enter_custom_name: '音声のカスタム名を入力してください',
    upload_complete: 'アップロード完了',
    uploading_in_progress: 'アップロード中...',
    podcast_stream_content: 'ポッドキャストのストリームコンテンツ',
    upload_podcast_cover:
      'ポッドキャストのカバー画像をアップロードしてください！',
    enter_podcast_name: 'ポッドキャスト名を入力してください！',
    podcast_topic: 'ポッドキャストのトピック',
    enter_podcast_topic: 'ポッドキャストのトピックを入力してください！',
    enter_podcast_desc: 'ポッドキャストの説明を入力してください！',
    number_of_speaker: '話者の数',
    select_the_number_of_speaker: '話者の数を選択してください！',
    number_of_episode: 'エピソード数',
    input_number_of_episode: 'エピソード数を入力してください！',
    podcast_length: 'ポッドキャストの長さ',
    select_the_podcast_length: 'ポッドキャストの長さを選択してください！',
    short_podcast: '短い (5〜10分)',
    medium_podcast: '中程度 (15〜18分)',
    long_podcast: '長い (18分以上)',
    name_of_host: 'ホスト名',
    enter_host_name: 'ホスト名を入力してください！',
    guest_name: 'ゲスト名',
    enter_guest_name: 'ゲスト名を入力してください！',
    choose_speaker_tone: '話者のトーンを選択',
    enter_speaker_tone: 'ポッドキャストのトーンを選択してください！',
    informal: 'カジュアル',
    formal: 'フォーマル',
    serious: '真面目',
    light_humor: '軽いユーモア',
    casual: 'くだけた',
    select_content_source: 'コンテンツソースを選択',
    from_internet: 'インターネットから',
    upload_pdf_internet: 'PDFまたはコンテンツページをアップロード',
    note: '注:',
    podcast_content_will_be_automatically_generated:
      'ポッドキャストの内容は、信頼できるインターネットソースから自動的に生成されます。',
    upload_or_select_file: 'ファイルをアップロードまたは選択してください！',
    podcast_eposode_title: 'ポッドキャストエピソードのタイトル',
    enter_podcast_title: 'ポッドキャストのタイトルを入力してください！',
    podcast_episode_des: 'ポッドキャストエピソードの説明',
    enter_podcast_episode_des: 'エピソードの説明を入力してください！',
    voice: '音声',
    music: '音楽',
    select_music: '音楽を選択',
    play_the_music: '音楽を再生',
    stop_the_music: '音楽を停止',
    context: 'コンテキスト',
    generate_audio_content_selected_voice:
      '選択された音声で音声コンテンツを生成します。',
    required_field_before_submitting:
      '送信前にすべての必須項目を入力してください。',
    regenerate_voice: '音声を再生成',
    generate_voice: '音声を生成',
    your_browser_does_not_suppot:
      'お使いのブラウザは音声をサポートしていません。',
    are_sure_leave_podcast:
      'このポッドキャストページを離れてもよろしいですか？',
    broadcast_ongoing: 'ライブ配信中です。本当にページを離れますか？',
    brodcaster_unavailable: 'ホストが利用できません。',
    setting_calender_for_booking: '予約のためのカレンダー設定',
    add_calender: 'カレンダーを追加',
    waiting_join_host: 'ホストが参加するのを待っています...',
    no_reviews_found: 'レビューが見つかりません',
    rated_already: 'このライブ配信は既に評価されています',
    downlink_png: 'PNGとしてダウンロード',
    downlink_jpg: 'JPGとしてダウンロード',
    donwload_file_format: 'ダウンロードするファイル形式を選択してください。',
    crashed_event:
      'イベントがクラッシュしました。新しいイベントを作成してください。ご不便をおかけして申し訳ありません。',
    prompt: 'プロンプト:',
    generated_image: '🚀 画像を生成中...しばらくお待ちください。',
    download_add: 'すべてダウンロード',
    setting_generator: 'ジェネレーター設定',
    enter_image_prompt: '画像のプロンプトを入力してください',
    image_prompt: '画像プロンプト',
    negative_prompt: '不要なコンテンツ',
    negative_image_prompt: '除外したい画像プロンプト',
    number_output: '生成する画像の数',
    enter_number_output: '数値を入力してください',
    image_style: '画像スタイル',
    output_format: '出力形式',
    seeds: 'シード',
    enter_seeds: 'シードを入力',
    performance_mode: 'パフォーマンスモード',
    quality: '品質',
    speed: '速度',
    balanced: 'バランス',
    guidance_scale: 'ガイダンススケール',
    enter_guidance: 'ガイダンス値を入力',
    select_image: '画像を選択',
    image_prmt: '画像プロンプト',
    generate_image_list_empty: '画像がありません。',
    knowledge_center_tooltrip_des:
      'AIはウェブ上の信頼できるソースに基づき、正確かつ関連性のある回答を提供します。',
    contexts: 'コンテキスト',
    ai_processing_video_sharebot: 'SharebotビデオのAI処理は24時間有効です。',
    remove_sharebot_video:
      'Sharebotビデオを削除するには、音声/ビデオセクションを削除してください。',
    remove_sharebot_video_audio:
      '音声セクションを削除するとSharebotリンクは削除されますが、コンテンツはライブラリに残ります。',
    monthly_live_stream:
      '月間ライブ配信制限を変更するには、サポートにご連絡ください。',
    monthly_transcribe_limit:
      '月間文字起こし制限を変更するには、サポートにご連絡ください。',
    must_be_one_to_three_hundred: '1～300分の間で入力してください。',
    all_field_required: 'すべての項目は必須です。',
    duration_minute: '所要時間（最大300分）',
    gender: '性別',
    select_gender: '性別を選択',
    accent: 'アクセント',
    select_accent: 'アクセントを選択',
    create_voice: '音声を作成',
    enter_voice_name: '音声名を入力してください',
    select_voice_gender: '音声の性別を選択してください',
    upload_voice: 'あなたの声をアップロード',
    upload_voice_mp_three: 'あなたの声をアップロード (.mp3)',
    cloned_voice: 'クローンされた音声',
    voice_type: '音声タイプ',
    select_voice_type: '音声タイプを選択',
    sharelook_stand: '標準',
    sharelook_premium: 'プレミアム',
    sharelook_custum_voice: 'カスタム（音声クローン）',
    create_auto_flow: '自動フローを作成',
    how_many_layers: 'レイヤー数',
    verify_selection: '選択を確認',
    uploaded_successful: 'アップロード成功',
    upload_failed: 'アップロード失敗',
    upload_only_five_mb: 'コンテンツをアップロード（PDFファイル、最大5件）',
    docs_from_org_library: '組織ライブラリからドキュメントを使用',
    failed_maze_generate: '迷路の生成に失敗しました。もう一度お試しください。',
    generate_metamaze: 'MetaMazeを生成中...',
    metamaze_being_generated:
      'あなたのMetaMazeは現在生成中です。処理が完了次第、メールで通知されます。',
    metamaze_generate_successfully: 'MetaMazeの生成に成功しました！',
    metamaze_with_proceed: 'これでMetaMazeを進めることができます。',
    ai_metamaze_generate: 'AI MetaMaze生成',
    what_kind_maze_create: 'どの種類の迷路を作成しますか？',
    manual_metamaze_creation: '手動でMetaMazeを作成',
    manually_maze_customizing_scnario:
      'シナリオとオプションツリーをカスタマイズして手動で迷路を作成',
    maze_ai_generated: 'AIで迷路を自動生成',
    unmark_deadend: '行き止まりのマークを解除',
    mark_deadend: '行き止まりとしてマーク',
    select_multiple_image_for_scenario:
      'シナリオのために複数の画像を選択できます。',
    select_your_image: '選択した画像',
    click_to_preview: 'クリックしてプレビュー',
    are_you_sure_delete_image: 'この画像を削除してもよろしいですか？',
    select_image_from_library: 'メディアライブラリから画像を選択',
    uploading_video: '動画をアップロード中...',
    tree_node_type: 'ツリーノードタイプ',
    correct_option_scenario: '正しいオプションまたはシナリオ',
    incorrect_option: '誤ったオプション',
    option_scenario_without_text: 'テキストのないオプションまたはシナリオ',
    dead_end: '行き止まり（赤い枠）',
    correct_path: '正しい経路',
    incorrect_path_not_selected_correct_option_path:
      '誤った経路 / 正しいオプションが選択されていない経路',
    double_click_on_tree_node:
      'ツリーノードをダブルクリックすると、テキストエディタが自動的にスクロールして、そのノードの内容を表示します。',
    add_scenario: 'シナリオを追加',
    add_option: 'オプションを追加',
    an_error_occured: 'エラーが発生しました:',
    download_summary: 'サマリーをダウンロード',
    step_wise_analysis: 'ステップごとの分析',
    step: 'ステップ',
    upload_csv_file: 'CSVファイルをアップロード',
    download_template_to_import:
      'インポート用のサンプルテンプレートをダウンロード',
    please_input_email: 'メールアドレスを入力してください。',
    email_at_least_three_characters: 'メールアドレスは3文字以上必要です。',
    email_cannot_be_empty: 'メールアドレスを空にできません。',
    input_email_in_new_line: 'メールアドレスを入力してください（1行に1つずつ）',
    role: '役割',
    select_role: '役割を選択してください',
    select_group: 'グループを選択してください',
    identification_number: '識別番号（任意）',
    add_identification_number: '識別番号を入力してください',
    pie_chart_of_all_categories:
      'Sharelook上の使用に基づく全カテゴリーの円グラフ。',
    total_sharesphere_question_answered_by_users:
      '現在の組織のユーザーによって回答されたShareSphereの質問の総数と、これらのカテゴリーごとの成功と失敗の結果。',
    voice_style_over_the_text: `入力したテキストに様々な音声スタイルを適用できます。Lorem Ipsumは印刷・組版業界のダミーテキストとして古くから使用されています。`,
    input_your_question: '質問を入力してください！',
    make_me_sales_manager: '例：私を営業マネージャーにするには？',
    enter_the_number_relevant_document:
      '関連するドキュメントの数を入力してください',
    please_wait_loading_result:
      '結果を読み込み中です。しばらくお待ちください...',
    no_result_found: '結果が見つかりません。もっと質問してみてください。',
    browser_doesnot_support_iframes:
      'お使いのブラウザはiframeに対応していません。',
    total_duration: '合計時間',
    number_of_messages: 'メッセージ数',
    search_result: '検索結果',
    count_result: '(1244件の結果)',
    your_other_interests: 'その他の興味',
    your_total_score: 'あなたの合計スコア',
    add_a_question: '+ 質問を追加',
    travia_question_empty: 'トリビア質問リストが空です。',
    video_generation_is_on_queue: '動画生成がキューに入っています！',
    checking_video_status: '動画の状態を確認中...',
    total_quizzes: 'クイズ合計',
    number_of_votes: '投票数',
    total_events: 'イベント合計',
    number_of_rates: '評価数',
    number_of_likes: 'いいね数',
    all_courses: 'すべてのコース',
    total_questions: '質問総数',
    no_skill_journey: 'スキルジャーニーは利用できません！',
    search_no_results: '- 結果がありません！',
    no_image_generated: '画像が生成されていません！',
    all_topic_in_this_lesson:
      'このレッスンの全トピックは削除されます。この操作は元に戻せません。',
    content_has_been_generated: 'このトピックのコンテンツが生成されました。',
    update_course_template: 'コーステンプレートを更新',
    add_course_template: 'コーステンプレートを追加',
    create_course_now: '今すぐコースを作成',
    preview_course: 'コースをプレビュー',
    layout: 'レイアウト',
    import_from_youtube: 'YouTubeからインポート',
    my_media_library: 'マイメディアライブラリ',
    bg_added: '背景が追加されました',
    add_bg: '背景を追加',
    booked_schedule: '予約済みスケジュール',
    add_schedule: 'スケジュールを追加',
    are_you_delete_schedule: 'このスケジュールを削除してもよろしいですか？',
    add_task: 'タスクを追加',
    update_calender: 'カレンダーを更新',
    manage_cookies: 'クッキーを管理',
    cookie_banner_text:
      '当社は、閲覧体験を向上させ、ウェブサイトのトラフィックを分析し、コンテンツをパーソナライズするためにクッキーを使用しています。お客様のプライバシーは私たちにとって重要です。',
    accept_all_cookies: 'すべてのクッキーを許可',
    reject_all: 'すべて拒否',
    customize: 'カスタマイズ',
    cookie_preferences_title: 'クッキー設定とプライバシー設定',
    privacy_subtitle:
      'お客様のプライバシーは大切です。許可するクッキーを選択してください。これらの設定はいつでも変更できます。',
    save_choices: '選択を保存',
    strictly_necessary: '必須クッキー',
    strictly_necessary_desc:
      'これらのクッキーは、ウェブサイトが正しく機能するために必要不可欠です。ページナビゲーション、フォーム送信、安全な領域へのアクセスなどの基本機能を有効にします。これらがないと、サイトは正常に動作しません。',
    analytics_performance: '分析とパフォーマンス',
    analytics_performance_desc:
      'これらのクッキーは、訪問者がウェブサイトをどのように利用しているかを匿名で収集・報告することで理解を深め、サイトのパフォーマンスとユーザー体験の改善に役立ちます。',
    advertising_marketing: '広告とマーケティング',
    advertising_marketing_desc:
      'これらのクッキーは、広告メッセージをより関連性の高いものにするために使用されます。同じ広告が繰り返し表示されるのを防ぎ、広告主に正しく広告を表示します。',
    tracking_social: 'トラッキングとソーシャルメディア',
    tracking_social_desc:
      'これらのクッキーは、ソーシャルメディア機能やパーソナライズされたコンテンツなど、拡張機能とカスタマイズを有効にします。当社または第三者プロバイダーによって設定される場合があります。',
    functional: '機能クッキー',
    functional_desc:
      'これらのクッキーは、チャットサポートやライブヘルプなど、ウェブサイト上での体験を向上させるインタラクティブ機能を有効にします。',
    your_rights: 'お客様の権利:',
    rights_description:
      '同意をいつでも撤回したり、データへのアクセスや削除を要求することができます。',
    withdraw_consent: 'すべての同意を撤回',

    how_many_options: 'オプションの数',
    add_content: 'コンテンツを追加',
    downloads_center: 'ダウンロードセンター',
    sharelook_help_center: 'Sharelookヘルプセンター',
    channel_outline: 'チャンネル概要',
    channel_objectives: 'チャンネルの目的',
    no_sop_available: '利用可能なSOPリストがありません。',
    generate_world_summary: 'シナリオを生成',
    world_scenario: '実際のシナリオ',
    drag_icon_hint:
      'ヒント: アイコンをキャンバス上にドラッグして位置を調整します',
    drag_text_hint:
      'ヒント: テキストをキャンバス上にドラッグして位置を調整します',
    edit_badge: 'バッジを編集',
    create_new_badge: '新しいバッジを作成',
    select_video_preview: 'プレビューする動画を選択',
    certificate_title_required: '証明書のタイトルは必須です',
    discard_changes: '変更を破棄',
    edit_certificate: '証明書を編集',
    add_another_logo: '別のロゴを追加',
    optional: '任意',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: '新しいクエストを作成',
    quest_filter_title: 'クエスト',
    sharelook_assistance: 'Sharelookコーチング',
    upload_scorm_zip: 'SCORM ZIPをアップロード',
    only_letters_numbers_space_dot_allowed:
      '使用できるのは英数字、スペース、ドットのみです！',
    video_playing: '再生中',
    course_price_message: `*このコースは組織内のユーザーにのみ公開され、市場での再販はできません。`,
    lesson_must_be_positive: 'レッスン数は1より大きくする必要があります',
    btn_proceed: '進む',
    rule_select_music: '音楽を選択してください',
    course_info: 'コース情報',
    content_selection: 'コンテンツ選択',
    course_content_source: 'コースコンテンツのソース',
    choose_how_to_source: 'このコースのコンテンツを取得する方法を選択:',
    automatic_selection: '自動選択',
    system_will_automatically_select_relavant_documents:
      'システムがライブラリから関連するドキュメントを自動的に選択します',
    manual_selection: '手動選択',
    choose_specific_documents_from_your_library:
      'ライブラリから特定のドキュメントを選択してください',
    upload_files: 'ファイルをアップロード',
    upload_new_documents:
      '新しいドキュメントをアップロード（PDF、DOC、DOCX、PPT、PPTX、TXT） - 最大5ファイル',
    file: 'ファイル',
    ready_to_upload: 'アップロード準備完了',
    clear_all: 'すべてクリア',
    confirm_course_wide_premiew: 'コース全体のプレビューを確認',
    generate_course_preview: 'コースプレビューを生成',
    instructions_across_the_course_to_generate:
      'コース全体にあなたの指示を適用してプレビューを生成します。保存または破棄する前にすべてを確認してください。',
    instruction_to_preview_course_wide: 'コース全体のプレビュー手順:',
    edit_content: 'コンテンツを編集',
    manage_course_template: 'コーステンプレートを管理',
    undo: '元に戻す',
    apply_changes: '変更を適用',
    characters: '文字数',
    apply_all: 'すべて適用',
    apply_to_all: 'すべてに適用',
    use_this_content: 'このコンテンツを使用',
    original: 'オリジナル',
    edited: '編集済み',
    edited_content_preview: '編集済みコンテンツのプレビュー',
    apply_edits_to_all_topices: 'すべてのトピックに編集を適用しますか？',
    current_editing_instructions_across_the_whole_course:
      '現在の編集指示をコース全体に適用します。保存前に統合プレビューを確認できます。',
    edit_content_instructions: 'コンテンツ編集の指示',
    generate_content_for_this_topic_instruction:
      'このトピックのコンテンツを指示に基づいて生成',
    descrip_edit_content:
      'このコンテンツをどのように編集するかを説明してください（例：短縮、簡略化、言い換えなど）',
    try_short_clear_direcctives: `短く明確な指示を使用してください。例：「主要なポイントを残して100語に短縮」「言葉を簡単に」「冗長な部分を削除して簡潔に」。`,
    we_preserve_the_core_meaning:
      'あなたの指示を適用する際に、主要な意味を保持します。',
    feedback_optional: 'フィードバック（任意）',
    write_your_feedback_here: 'ここにフィードバックを入力',
    from_web: 'ウェブから',
    from_desktop: 'デスクトップから',
    pleae_wait_processing: '処理中です。しばらくお待ちください...',
    create_simulation_from_screen_capture:
      '画面キャプチャからシミュレーションを作成',
    sharelook_not_found: 'ShareLookが見つかりません',
    sharelook_screen_capture_application_not_be_opened:
      'ShareLook画面キャプチャアプリケーションを開けません。お使いのコンピュータにインストールされていない可能性があります。',
    download_sharelook: 'ShareLookをダウンロード',
    launch_sharelook_application: 'ShareLookアプリを起動',
    this_will_open_the_sharelook_application_for_screen_capture:
      'これにより、ShareLookアプリが起動して画面キャプチャが行えます。',
    sharelook_dosenot_open:
      'ShareLookが開かない場合は、インストールされていない可能性があります。',
    open_sharelook: 'ShareLookを開く',
    download_app: 'アプリをダウンロード',
    background_image_setting: '背景画像設定',
    current_image: '現在の画像',
    change_image: '画像を変更',
    remove_image: '画像を削除',
    no_background_image_selected: '背景画像が選択されていません',
    add_image: '画像を追加',
    this_will_open_for_screen_recording:
      'これにより、ShareLookアプリが起動して画面録画が行えます。',
    ai_image_generation: 'AI画像生成',
    image_edit: '画像編集',
    text_to_image: 'テキストから画像へ',
    output_gallary: '出力ギャラリー',
    instant_generation: '即時生成可能',
    prompt_and_unleash_the_power:
      'プロンプトを入力してAIの力を引き出しましょう',
    use_this_image: 'この画像を使用',
    error_generating: '生成中にエラーが発生しました。',
    generation_tips: '生成のヒント',
    detailed_descriptions_for_more_accurate_results:
      'より正確な結果を得るには、詳細な説明を使用してください',
    reference_image: '参照画像',
    select_pixel_image: 'ピクセル画像を選択',
    max_mb: '最大50MB',
    please_enter_text_to_appear_image:
      '画像に表示するテキストを入力してください',
    enter_text_to_apear_in_the_image: '画像に表示するテキストを入力',
    generate_image: '画像を生成',
    prompt_assistant: 'プロンプトアシスタント',
    generate_image_using_suggested_prompt:
      '提案されたプロンプトを使用して画像を生成',
    talk_to_ai_about_the_image_generate: '生成したい画像についてAIと話す',
    ask_for_prompt_suggestions: 'プロンプトの提案を依頼...',
    enter_a_search_term_to_find_stock_images:
      'ストック画像を検索するキーワードを入力',
    choose_your_content_source: 'コンテンツソースを選択:',
    upload_new_document_from_your_device:
      'デバイスから新しいドキュメントをアップロード',
    automatic_library_selection: '自動ライブラリ選択',
    system_automatically_selects_relevant_document:
      'システムが関連するドキュメントを自動的に選択します',
    manual_library_selection: '手動ライブラリ選択',
    generate_content: 'コンテンツを生成',
    add_to_current_page: '現在のページに追加',
    generate_bullet_points: '箇条書きを生成',
    generating: '生成中',
    this_may_take_a_few_moments: '少し時間がかかる場合があります',
    apply_to_page: 'ページに適用',
    scenario_escription: 'シナリオの説明:',
    feedback: 'フィードバック',
    form_mode: 'フォームモード',
    chat_mode: 'チャットモード',
    this_will_generate_a_continuation_of_the_seleccted_story:
      '選択されたストーリーの続きがAIによって生成されます。',
    continue_this_story_question: 'このストーリーを続けますか？',
    continue_this_story: 'このストーリーを続ける',
    what_will_happen: '何が起こるか:',
    the_ai_will_analyze_the_existing_story_content:
      'AIが既存のストーリー内容を分析します',
    generate_a_natural_continuation_that_follows_the_same_tone:
      '同じトーンとスタイルに従った自然な続きの生成',
    create_new_content_that_build_upon_the_current_narrative:
      '現在の物語に基づいて新しいコンテンツを作成する',
    this_process_may_take_a_few_moments_to_complete:
      'このプロセスの完了には数秒かかる場合があります。',
    no_existing_stories_found_for_this_course:
      'このコースには既存のストーリーが見つかりませんでした。',
    create_your_first_story: '最初のストーリーを作成',
    existing_stories: '既存のストーリー',
    create_new_story: '新しいストーリーを作成',
    tone: 'トーン',
    style: 'スタイル',
    genre: 'ジャンル',
    loading_your_stories: 'ストーリーを読み込み中...',
    edit_story: 'ストーリーを編集',
    story_preferences: 'ストーリーの設定',
    please_input_your: '入力してください',
    add_character_names_and_press_enter:
      'キャラクター名を追加してEnterを押してください',
    select_or_type_your: '選択するか入力してください',
    enter_your: '入力してください',
    position_of_the_story_in_the_lesson:
      'レッスン内でのストーリーの位置。この位置にブロックとしてストーリーが追加されます。',
    save_previous_content_on_the_pages: '前のページ内容を保存',
    the_existing_content_in_the_selected_pages:
      '選択したページの既存の内容は生成されたストーリーで置き換えられます。',
    real_world_scenario: '現実世界のシナリオ',
    add_optional_instructions:
      'オプションの指示を追加 (トーン、長さ、対象者など)',
    ready_to_enerate_your_real_world_scenario:
      '現実世界のシナリオを生成する準備ができました',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      '"現実世界のシナリオを生成" をクリックして、レッスン内容に基づいたリアルなシナリオを作成します。',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AIがレッスンのトピックと内容を分析します',
    generate_a_practical_real_world_scenario:
      '実用的な現実世界のシナリオを生成',
    you_can_then_edit_and_customize_the_result:
      '結果を編集してカスタマイズできます',
    add_it_as_a_new_page_to_your_lesson: 'レッスンに新しいページとして追加',
    regenerate_with_instructions: '指示付きで再生成',
    add_real_world_scenario: '現実世界のシナリオを追加',
    generate_real_world_scenario: '現実世界のシナリオを生成',
    simulation_has_been_stopped: 'シミュレーションが停止しました！',
    loading_simulation: 'シミュレーションを読み込み中...',
    you_have_exhausted_all_the_attempts: '全ての試行を使い果たしました',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'このページのシナリオを確認し、下の選択肢から正しい答えを選択してください。',
    attempts_limit_reached:
      '試行回数の上限に達しました。再度プレイできますが、スコアは保存されません。',
    play_again: '再プレイ',
    import_music_from_computer: 'コンピュータから音楽をインポート',
    more: 'もっと見る',
    no_badge_yet: 'まだバッジはありません',
    competition_filter: 'コンペティションフィルター',
    global_leaderboard: 'グローバルランキング',
    placeholder_for_the_global_leaderboard:
      'これはグローバルランキングのプレースホルダーです。',
    badge_editor: 'バッジエディター',
    adjust_the_appearance_of_this_badge_icon:
      'このバッジアイコンの見た目を調整します。変更はこのバッジにのみ適用されます。',
    badge_style: 'バッジスタイル',
    the_image_must_be_pixels: '画像は200x200ピクセルである必要があります。',
    badge_name: 'バッジ名',
    badge_descrription: 'バッジの説明',
    enter_badge_criteria: 'バッジの条件を入力',
    discard: '破棄',
    badge_enable: 'バッジ有効化',
    award_users_with_badges_to_highlight_the_milestones:
      'ユーザーにバッジを付与して、学習のマイルストーンを強調します。',
    badge_types: 'バッジの種類',
    enable_or_disable_specific_badge_types_for_your_users:
      'ユーザー向けに特定のバッジの種類を有効または無効にする',
    levels_enabled: 'レベル有効化',
    level_rules: 'レベルルール',
    points: 'ポイント',
    add_new_level: '新しいレベルを追加',
    add_level: 'レベルを追加',
    points_enabled: 'ポイント有効化',
    learning_activities_and_encourage_healthy_competition:
      'さまざまな学習活動に対してポイントを付与し、健全な競争を促進します。',
    award_points: 'ポイントを付与',
    the_following_equates_the_value_of_one_item_completion:
      '以下は1項目完了の価値に相当します',
    general: '一般',
    others: 'その他',
    certificate: '証明書',
    quiz_passed: 'クイズ合格',
    tip_approved: 'ヒント承認済み',
    tip_liked: 'ヒントがいいねされました',
    rewards: '報酬',
    offer_discounts_when_learners_achieve:
      '学習者が一定のポイント、バッジ、またはレベルを達成した場合に割引を提供します。',
    give_rewards: '報酬を与える',
    discount_course_purchases_by: 'コース購入の割引',
    with_points_more_than: 'ポイント以上で',
    with_badges_more_than: 'バッジ以上で',
    with_level_upwards_more_than: 'レベル以上で',
    leaderboard: 'ランキング',
    leaderboard_enabled: 'ランキング有効',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'ランキングはユーザーに、他の人と比較した学習進捗を提供します。',
    show_levels: 'レベルを表示',
    show_points: 'ポイントを表示',
    show_badges: 'バッジを表示',
    show_courses: 'コースを表示',
    show_certificates: '証明書を表示',
    leaderboard_settings: 'ランキング設定',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      '学習者のモチベーションを高めるランキング体験を設定します。',
    award_users_with_points_for_different_learning_activities:
      'さまざまな学習活動に対してポイントを付与します。',
    badge_set: 'バッジセット',
    choose_the_type_of_badges_your_users:
      '学習中にユーザーが獲得するバッジの種類を選択',
    levels: 'レベル',
    Levels_represent_the_stages: 'レベルはユーザーの学習段階を表します。',
    enabled: '有効',
    disabled: '無効',
    quick_select: 'クイック選択',
    yesterday: '昨日',
    last_week: '先週',
    Last_month: '先月',
    last_quarter: '前四半期',
    historical_leaderboard: '過去のランキング',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'パフォーマンスを追跡して、仲間内での順位を確認',
    time_period: '期間',
    page_of: 'ページ 1 / 1',
    edit_competition: 'コンペティションを編集',
    create_competition: 'コンペティション作成',
    arrow_right: '右矢印',
    update_competition: 'コンペティション更新',
    competition_title: 'コンペティションタイトル',
    enter_competition_title: 'コンペティションタイトルを入力',
    enter_competition_description: 'コンペティションの説明を入力',
    leaderboard_skill: 'スキル',
    select_a_skill: 'スキルを選択',
    no_skills_found: 'スキルが見つかりません',
    competition_period: 'コンペティション期間',
    add_badge_rule: 'バッジルールを追加',
    create_badge: 'バッジを作成',
    add_level_rule: 'レベルルールを追加',
    selected_participants: '選択された参加者',
    no_participants: '参加者なし',
    start_end_date: '開始–終了日',
    created_date: '作成者',
    new_competition: '新しいコンペティション',
    competitions_list: 'コンペティション一覧',
    search_competitions: 'コンペティションを検索...',
    are_you_sure_you_want_to_delete_the_competition:
      'このコンペティションを削除してもよろしいですか？',
    history: '履歴',
    export: 'エクスポート',
    search_by_name: '名前で検索...',
    no_historical_data_available_for_the_selected_period:
      '選択した期間の履歴データはありません。',
    no_leaderboard_data_available: 'ランキングデータはありません。',
    competitions: 'コンペティション',
    leaderboards: 'ランキング',
    welcome_back: 'お帰りなさい',
    track_your_performance_and_see:
      'パフォーマンスを追跡して、仲間内での順位を確認',
    team_leaderboard: 'チームランキング',
    try_again: '再試行',
    no_competitions_for_search: '検索対象のコンペティションはありません',
    no_competitions_available: '利用可能なコンペティションはありません',
    no_competitions_matching_search:
      '検索に一致するコンペティションはありません。検索条件を変更するか、後で確認してください。',
    no_competitions_general:
      '現在、コンペティションは設定されていません。後で確認するか、管理者にお問い合わせください。',
    media_management: 'メディア管理',
    badgess_set: 'バッジセット',
    choose_the_default_visual_style_for_badge:
      'プラットフォームで使用するバッジアイコンのデフォルトスタイルを選択。',
    enable_badges: 'バッジを有効にする',
    add_badge: 'バッジを追加',
    min: '最小',
    max: '最大',
    your_rank: 'あなたのランク',
    your_points: 'あなたのポイント',
    your_level: 'あなたのレベル',
    rank: 'ランク #',
    level: 'レベル',
    progress: '進捗',
    new_folder: '新しいフォルダー',
    file_upload: 'ファイルアップロード',
    writer: '作成者',
    text_documents: 'テキストドキュメント',
    spreadsheets: 'スプレッドシート',
    impress: 'Impress',
    presentations: 'プレゼンテーション',
    capture_desktop_screen: 'デスクトップ画面をキャプチャ',
    capture_desktop_screens: 'デスクトップ画面をキャプチャ',
    your_documents: 'あなたのドキュメント',
    manage_your_videos_images_audio_files:
      'コンテンツ作成に使用する動画、画像、音声ファイルなどを管理します。',
    your_organization_documents: '組織のドキュメント',
    keep_your_organization_creative_assets_organized:
      '組織のクリエイティブ資産を整理してアクセス可能に保ち、チームワークとコンテンツ制作を効率化します。',
    your_public_documents: '公開ドキュメント',
    curated_collection_of_media_assets_available:
      '誰でも利用可能な厳選メディアコレクション—探索、再利用、作成が可能。',
    your_download_center_documents: 'ダウンロードセンタードキュメント',
    repository_of_approved_media_assets_for_download:
      'プロジェクトで使用するために承認されたメディア資産のリポジトリ。',
    search_files_and_folders: 'ファイルとフォルダーを検索...',
    home: 'ホーム',
    folders: 'フォルダー',
    folder_name: 'フォルダー名',
    owner: '所有者',
    last_updated: '最終更新',
    action: '操作',
    no_folders_found: 'フォルダーが見つかりません',
    files: 'ファイル',
    enabling_ai: 'AIを有効化中...',
    rename: '名前を変更',
    copy: 'コピー',
    move: '移動',
    verson_history: 'バージョン履歴',
    manage_permission: '権限管理',
    generate_audit_report: '監査レポートを生成',
    last_edited: '最終編集',
    no_files_found: 'ファイルが見つかりません',
    are_you_sure_you_want_to_make_this_item_public:
      'この項目を公開してもよろしいですか？公開ライブラリにコピーされます。',
    move_to_organization: '組織に移動',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'この項目を組織ライブラリにコピーしてもよろしいですか？',
    are_you_sure_you_want_to_make_this_item_private:
      'この項目を非公開にしてもよろしいですか？自分のライブラリにコピーされます。',
    date_modified: '変更日',
    workflow_management: 'ワークフロー管理',
    configure_editors_approvers_and_viewers_for_this_document:
      'このドキュメントの編集者、承認者、閲覧者を設定します。',
    error_Loading_editor: 'エディタの読み込みエラー',
    debug_info: 'デバッグ情報',
    loading_editor: 'エディタを読み込み中...',
    submitted_for_review: 'レビュー提出済み',
    editors: '編集者',
    no_editors_added_yet:
      '編集者はまだ追加されていません。"編集者を追加"をクリックして追加してください。',
    add_editor: '編集者を追加',
    approvers: '承認者',
    no_approvers_added_yet:
      '承認者はまだ追加されていません。"承認者を追加"をクリックして追加してください。',
    add_approvers: '承認者を追加',
    viewer: '閲覧者',
    no_viewers_added_yet:
      '閲覧者はまだ追加されていません。"閲覧者を追加"をクリックして追加してください。',
    add_viewer: '閲覧者を追加',
    are_you_sure_you_want_to_delete_the_selected_items:
      '選択した項目を削除してもよろしいですか？'
  },
  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'カテゴリー概要',
    triviaReport: 'ShareSphereカテゴリー',
    overviewGraph: 'カテゴリー概要グラフ',
    category: 'カテゴリー',
    phCategory: 'カテゴリーを選択',
    podcast: 'ポッドキャスト、音楽、ストーリー',
    pastPodcast: '過去のポッドキャスト',
    upcomingPodcast: '今後のポッドキャスト',
    podcastLanguageTitle: 'ポッドキャスト、音楽、ストーリーの言語',
    podcastLanguageCheckbox: 'ポッドキャストのAI生成言語',
    howRate: 'このポッドキャストをどのように評価しますか？',
    podcastSubmit: '送信',
    podcastGuest: 'ゲストスピーカー：',
    podcastReview: 'レビュー',
    podcastEpishode: 'エピソード',
    podcastEnd: 'ポッドキャストは終了しました',
    date_podcast: 'ポッドキャスト日付',
    skill_not_found: '申し訳ありません！スキルジャーニーが見つかりません。',
    coaching: 'コーチング',
    webinar: 'ウェビナー',
    public_conference: '公開会議',
    skill_journey_subtitle:
      'スキルジャーニーの設定を追加し、誰がスキルジャーニーを表示・操作できるか選択してください。',
    enable_white_label: 'ホワイトラベルを有効にする',
    create_new_event_org: '組織のための新しいイベントを作成する。',
    create_new_event_marketplace:
      'マーケットプレイスのための新しいイベントを作成する。',
    create_new_event_both:
      '組織とマーケットプレイスの両方のために新しいイベントを作成する。',
    event_outline: 'イベント概要を入力してください',
    event_obj: 'イベント目標を入力してください',
    event_description: 'イベント説明を入力してください',
    create_new_metamaze_org: '組織のための新しいMetaMazeを作成する。',
    create_new_metamaze_marketplace:
      'マーケットプレイスのための新しいMetaMazeを作成する。',
    create_new_metamaze_both:
      '組織とマーケットプレイスの両方のために新しいMetaMazeを作成する。',
    add_key_words: 'キーワードを追加',
    press_enter_make_keyword: 'キーワードを作成するにはEnterを押してください',
    disable_skip_quiz: 'クイズのスキップを無効にする',
    warning_complete_quiz: '続行するにはクイズを完了してください。',
    signup_email_verification:
      'ご提供いただいたメールアドレスに確認リンクを送信しました。そのリンクにアクセスして登録を確認してください。',
    verifying_registration: 'アカウント登録を確認しています...',
    reset_password_linK:
      'ご提供いただいたメールアドレスにリンクを送信しました。そのリンクにアクセスして新しいパスワードを設定してください。',
    reset_email_error:
      'このメールアドレスのユーザーが見つかりません。代わりにユーザー名でお試しください！',
    first_name: '名',
    last_name: '姓',
    error_firstName: '名を入力してください',
    error_sharebot_organization: '組織名を入力してください',
    error_lastName: '姓を入力してください',
    private_conference: 'プライベート会議',
    public_conference: '公開会議',
    discussion_room: 'ディスカッションルーム',
    training_no_courses: '現在、登録されているコースはありません。',
    training_no_events: '現在、登録されているイベントはありません。',
    allow_sharing_trainer_info:
      'マーケットプレイスでメールアドレスの共有を許可する',
    error_username_space: 'ユーザー名にスペースは使用できません。',
    error_sharebot_organization_space: '組織名にスペースは使用できません。',
    edit_permission: '編集権限',
    valid_price: '価格は0より大きくなければなりません',
    course_price_message: `*コースは組織が購入したユーザー数にのみ公開され、マーケットプレイスでの再販はできません`,
    valid_edit_price: '編集価格は購入価格より低くなければなりません。',
    my_calendar: 'マイカレンダー',
    error_valid_firstName: '有効な名を入力してください。',
    error_valid_organization: '有効な組織名を入力してください。',
    error_valid_lastName: '有効な姓を入力してください。',
    error_name_spaces: '名前にスペースは使用できません',
    items: 'アイテム',
    publish_to_channel: '自分のチャンネルコレクションに公開',
    create_a_channel: 'チャンネルを作成',
    create_a_trivia: 'トリビアゲームを作成',
    create_a_new_channel: '新しいチャンネルを作成',
    add_videos: 'ビデオを追加',
    save_and_continue: '保存して続行',
    channel: 'チャンネル',
    channels: 'チャンネル',
    view_channel: 'チャンネルを見る',
    edit_channel: 'チャンネルを編集',
    delete_channel: 'チャンネルを削除',
    my_video_channels: 'マイビデオチャンネル',
    training_no_channel: '現在、登録されているチャンネルはありません。',
    monthly_price_required: '月額料金が必要です',
    yearly_price_required: '年額料金が必要です',
    one_time_price_required: '一回限りの料金が必要です',
    marketplace_quantity: 'USD',
    report_webinar: 'ウェビナー',
    report_coaching: 'コーチング',
    report_channel: 'チャンネル',
    report_public_conference: '公開会議',
    report_maze: 'メイズ',
    channel: 'チャンネル',
    edit_price: '価格を編集 ($)',
    quantity: '数量',
    payment_type: '支払いタイプ',
    total_amount: '合計金額 ($)',
    net_amount: '正味金額 ($)',
    edit_option: '編集オプション',
    marketplace_price: '価格 ($)',
    market_name: '名前',
    duration_min: '時間（分）',
    users_total: 'ユーザー（合計）',
    sales_total: '売上合計 (USD)',
    search_coaching: 'コーチングを検索',
    search_channel: 'チャンネルを検索',
    search_webinar: 'ウェビナーを検索',
    search_maze: 'メイズを検索',
    search_public_conference: '公開会議を検索',
    buyer_type: '購入者タイプ',
    quanity: '数量',
    channel_unit_amount: '正味金額 ($)',
    channel_updated_at: '更新日時',
    month_price: '価格（月）',
    year_price: '価格（年）',
    one_time_price: '価格（一回限り）',
    sharebot_organization: '新しい組織名を追加',
    share_sphere: 'ShareSphere',
    ai_course_title: 'コースタイトル',
    ai_input_course_title: 'コースタイトルを入力してください！',
    learning_objective_label: '学習目標',
    learning_objective_message: '学習目標を入力してください！',
    standard_question: '学習者が従うべき標準はありますか？',
    standard_details_label: '標準の詳細',
    standard_details_message: '標準の詳細を入力してください！',
    estimated_duration_label: 'コースの推定時間（分）',
    estimated_duration_message: '推定時間を入力してください！',
    min_duration_message: '最低時間は5分です。',
    ai_mins: '25分',
    industry_specific_question: '業界特化型ですか？',
    industry_label: '業界を指定してください',
    industry_message: '業界を入力してください！',
    ai_course_creation: 'AIコース作成',
    course_generated: 'Sharelookによって生成されたコース',
    ai: 'AI',
    ai_you: 'あなた',
    ai_prompt_ready: 'プロンプトが準備できました。目次の生成準備が整いました。',
    ai_unable_respond:
      '申し訳ありません！AIはあなたのプロンプトに応答できません。もう一度お試しください。',
    ai_hide_toc: '目次を隠す',
    ai_preview_toc: '目次をプレビュー',
    ai_generate_toc_now: '今すぐ目次を生成',
    ai_creation_course_title: 'コースタイトル：',
    ai_creation_industry_specific: '業界特化型ですか：',
    ai_creation_industry: '業界：',
    ai_creation_standard_needed: '学習者が従うべき標準はありますか？：',
    ai_creation_standard_details: '標準の詳細：',
    ai_creation_estimated_duration: 'コースの推定時間（分）：',
    minutes: '分',
    ai_creation_learning_objective: '学習目標：',
    setup_again: '再設定',
    ai_creation_confirm_title: '本当にフォームを再設定しますか？',
    ai_creation_confirm_content:
      'チャットと生成したすべてのコンテンツがリセットされます。',
    ai_toc: '目次',
    ai_note_topic:
      '注意：レッスン内のトピックはドラッグ＆ドロップで順序を変更できます。',
    ai_add_topic: '+ トピックを追加',
    add_topic: 'トピックを追加',
    add_lesson: 'レッスンを追加',
    add_new_lesson: '新しいレッスンを追加',
    ai_add_lesson: '+ レッスンを追加',
    attention: '注意',
    before_varifying: '確認前',
    ai_save_later: '後で保存',
    ai_download_word_doc: 'Wordドキュメントとしてダウンロード',
    ai_download_course_word_doc: 'コースをWordドキュメントとしてダウンロード',
    ai_create_course_button: 'コースを作成',
    ai_generate_course_content: 'コースコンテンツを生成',
    ai_out_of: 'のうち',
    ai_subtopic_failed_content:
      'サブトピックのコンテンツ生成に失敗しました。"コースコンテンツを生成"をクリックして、該当サブトピックのみコンテンツを生成してください。',
    ai_edit_topic: 'トピックを編集',
    ai_edit_lesson_title: 'レッスンタイトルを編集',
    ai_save_topic: 'トピックを保存',
    ai_save: '保存',
    ai_save_lesson_title: 'レッスンタイトルを保存',
    ai_add_new_topic: '新しいトピックを追加',
    ai_download_ref: '参考文献付きでダウンロード',
    ai_download_ref_content:
      '参考文献付きのWordドキュメントとしてコースをダウンロードします。',
    ai_download_without_ref: '参考文献なしでダウンロード',
    ai_download_two_word: '2つのWordドキュメントがダウンロードされます：',
    ai_download_two_word_content_one: '- 参考文献なしのメインコンテンツ',
    ai_download_two_word_content_two:
      'もう一つは参考文献リストのみでコンテンツなしです。',
    ai_manage_content: 'コンテンツ管理',
    ai_add_content_from_internet: '+ インターネットからコンテンツを追加',
    ai_confirm_start: '開始を確認',
    ai_Verify: '確認',
    ai_undo_warning:
      'この処理には時間がかかる場合があります。生成が完了するまでこのウィンドウを閉じないでください。取り消しはできません。',
    ai_verified_content:
      'コンテンツを確認しました。確認後は現在の内容でAIアシスタントとのチャットに戻れません。',
    ai_want_proceed: '本当に続行しますか？',
    upload_simulation: 'シミュレーションをアップロード',
    name_simulation: 'シミュレーション名',
    selected_simulation_files: '選択されたシミュレーションファイル',
    score_between_one_hundred: 'スコアは1から100の間でなければなりません。',
    are_sure_simulation:
      'このシミュレーションファイルを削除してもよろしいですか？',
    required_simulation: 'スコアは必須です',
    required_section_file: 'セクションファイルは必須です',
    simulation: 'シミュレーション',
    simulation_quiz_games: 'ゲームにクイズを追加する必要があります',
    simulation_alert_des:
      'すべての質問の回答タイプが単一または複数である場合にのみゲームを追加できます。',
    alert_info: '情報',
    ai_number_quiz: 'クイズの数',
    ai_point: 'ポイント',
    ai_points: 'ポイント',
    val_required: '必須',
    games: 'ゲーム',
    add_simulation: 'シミュレーションを追加',
    text_tiewer: 'テキストビューア',
    back_to_account: 'アカウントに戻る',
    delete_account: 'アカウントを削除',
    delete_account_title: 'アカウントを削除しますか？？？',
    delete_account_subtitle: 'ここからアカウントを削除できます。',
    delete_account_cannot_undo:
      'アカウントを削除しようとしています。この操作は取り消せません。',
    account_org_profile:
      '作成したすべてのコース、組織プロフィール、およびすべての設定も失われます。',
    deleting_account_database:
      'アカウントの削除により、データベースからすべてのデータが削除されます。',
    account_confirm_delete: '本当にアカウントを削除しますか？',
    action_cannot_be_undone: 'この操作は取り消せません。',
    account_delete_message_success: 'アカウントが正常に削除されました。',
    message_edit: '編集',
    message_delete: '削除',
    message_reply: '返信',
    attached_file: '添付ファイル',
    attach_file: 'ファイルを添付',
    attach_des: '最大25MBのファイルサイズ',
    view: '表示',
    go_to_marketplace: 'マーケットプレイスへ',
    learning_center: 'ラーニングセンター',
    knowledge_center: 'ナレッジセンター',
    sharebot: 'シェアボット',
    sharebot_help_message: '今日はどのようにお手伝いしましょうか？',
    my_organization: '私の組織',
    world_knowledge: '世界の知識',
    welcome_to_sharelook: 'Sharelookへようこそ！',
    sharelook_you_want_go: '今日はどこに行きたいですか？',
    shareLook_learning_management_system:
      'ShareLookの学習管理システムにアクセスして、組織内のライブイベントやコースなどの学習リソースを作成または利用できます。',
    shareLook_powerful_ai_system:
      'ShareLookの強力なAIシステムにアクセスして、PDF文書をアップロードし、数秒で役立つインサイトを得られます。組織にアップロードされたリソースに基づく迅速な回答や、世界の知識セクションの一般的なAIシステムからの回答が取得可能です。',
    edit_now: '今すぐ編集',
    sharelook_log_out:
      'Sharelookからログアウトしました。ログインしてください！',
    sorry_error: '申し訳ありません！エラーが発生しました。',
    login: 'ログイン',
    refresh_page: 'ページを更新',
    just_a_moment: '少々お待ちください',
    enter_lname_fname: '続行するには名前と姓を入力してください。',
    procced_to_sharelook: 'Sharelookへ進む',
    option_one: 'オプション1',
    option_two: 'オプション2',
    selected_image: '選択した画像：',
    add_text: 'テキストを追加',
    linkdin_is_required: 'Linkedinは必須です。',
    bio_is_required: 'プロフィール紹介は必須です。',
    save_user_information: 'ユーザー情報を保存',
    select_all: 'すべて選択',
    enable_ai: 'AIを有効にする',
    load_more: 'もっと読み込む',
    channel_id: 'チャンネルID。',
    send: '送信',
    v4: '情報',
    subscription: 'サブスクリプション',
    reset_user_flag: 'ユーザーフラグをリセット',
    delete_my_accont: 'アカウントを削除する',
    sharebot_sub_error:
      'サブスクリプションの取得中にエラーが発生しました。再試行してください！',
    sharebot_no_sub: '現在有効なサブスクリプションはありません。',
    sharebot_dont_sub: '過去のサブスクリプションはありません。',
    sharebot_prev_sub: '以前のサブスクリプション',
    sharebot_sub: 'ShareBotサブスクリプション',
    sharebot_un_sub: 'ShareBotサブスクリプション解除',
    sharebot_no_available: '説明がありません',
    sharebot_start_date: '開始日：',
    sharebot_end_date: '終了日：',
    sharebot_sure: 'よろしいですか？',
    sharebot_do_you_want: '次の操作を行いますか？',
    unsubscribe: '購読解除',
    unsubscribe_what: '購読解除しますか？',
    subscribe: '購読',
    subscribe_what: '購読しますか？',
    subscribe_now: '今すぐ購読',
    confirm: '確認',
    sharebot_intel_knowledge_center:
      'ShareBotのインテリジェントナレッジセンター',
    sharebot_welcome_paragraph:
      'ShareBotのナレッジセンターへようこそ。これは、専門家が情報にアクセスし、協力する方法を変革する高度なAIチャットボットです。',
    expired: '期限切れ',
    active: '有効',
    Inactive: '無効',
    yearly_subscription: '年次サブスクリプション',
    monthly_subscription: '月額サブスクリプション',
    no_sharebot_org: 'ShareBotの組織がありません',
    sharebot_start_free_trial: '無料トライアルを開始',
    sub_month: '月額サブスクリプション',
    sub_year: '年額サブスクリプション',
    question_per_month: 'データストレージ（1TB）と月あたり1000の質問',
    sharebot_para:
      '続行すると、組織が即座に削除されることを確認したことになります。この操作により、ShareBotによって提供されるすべての貴重な洞察が失われ、元に戻すことはできません。',
    cancelled_date: 'キャンセル日:',
    live_straming_para:
      '月間ライブストリーミング制限を変更したい場合は、こちらにご連絡ください',
    sharelook_agree: 'Sharelookの',
    terms_condition: '利用規約',
    and: 'および',
    privacy_policy: 'プライバシーポリシー',
    save_for_later: '後で保存',
    ai: 'AI',
    no_video_yet: 'まだビデオが選択されていません！',
    are_you_sure_delete_video: 'このビデオを削除してもよろしいですか？',
    video_des: '説明',
    video_now: '現在',
    video_playing: '再生中:',
    video_no: 'ビデオ番号',
    ai_generated_course: 'AI生成コース',
    create_course_on_our_own: '自分でコースを作成する',
    ai_Assisted_ourse_reation: 'AI支援コース作成',
    pending: '保留中',
    published: '公開済み',
    intro_course: 'コースに追加しますか？',
    clone_course: 'このコースをクローンしますか？',
    browser_audio_not_support:
      'お使いのブラウザはaudioタグをサポートしていません。',
    audio_popup_content:
      '入力したテキストに多くの音声スタイルを使用できる場所です。これは印刷業界のダミーテキスト「Lorem Ipsum」です。',
    close: '閉じる',
    podcast_rec: '録音中',
    create_podcast: 'ポッドキャストを作成',
    add_admin: '管理者を追加',
    delete_all: 'すべて削除',
    ai_podcast_audio: 'AIポッドキャスト音声',
    language: '言語',
    podcast_download_content:
      '*AIの音声ファイルを編集のためにダウンロードして、独自の音声ファイルに変換します。',
    upload_audio: '音声をアップロード',
    browser_do_not_support_audio:
      'お使いのブラウザはaudio要素をサポートしていません。',
    upload_cover: 'カバー画像をアップロード',
    upload_ai_creator: 'AI作成者をアップロード',
    required_cover_image: 'カバー画像は必須です！',
    room_required_name: 'ポッドキャスト名は必須です！',
    add_guest_list: 'ゲストリストを追加してください！',
    podcast_add_participants: '参加者を追加',
    topic_required: '少なくとも1つのトピックが必要です',
    podcast_description: '説明',
    podcast_date: '日付',
    date: '日付',
    podcast_time: '時間',
    podcast_to: 'から',
    podcast_all_day: '終日',
    podcast_start_date_time: '開始日時が必要です！',
    podcast_id: 'ID',
    selected_user: '選択したユーザーを招待',
    see_more: 'もっと見る',
    see_less: '表示を減らす',
    no_review_yet: 'まだレビューがありません。最初のレビューをしてください。',
    request_to_speak: 'ユーザーの発言リクエストを受け入れますか？',
    kick_user: 'このユーザーを退出させますか？',
    accept_request: 'リクエストを受け入れる',
    kick: '退出',
    started: '開始済み',
    end: '終了',
    join_now: '今すぐ参加',
    podcast_end: 'ポッドキャストは終了しました',
    connecting: '接続中...',
    knowledge_center_know_today: '今日は何を知りたいですか？',
    knowledge_center_question: '最初に質問を入力してください',
    knowledge_center_error: '申し訳ありません！エラーが発生しました。',
    knowledge_center_tooltrip:
      'ShareLookの組織リポジトリ内の学習リソースから、適切な参照とPDF文書のプレビュー・ダウンロード機能を使って、迅速に答えを得ることができます。',
    my_organization: '私の組織',
    world_knowledge: '世界の知識',
    open_file: 'ファイルを開く',
    reference: '参照',
    are_you_cancel: 'キャンセルしてもよろしいですか？',
    are_you_remove_media: 'メディアを削除してもよろしいですか？',
    terms_agree: 'これらに同意します',
    ready: '準備完了',
    send_email: 'メールを送信',
    active_users: 'アクティブユーザー',
    sign_up_user: 'サインアップしたユーザー',
    non_sign_up_user: '未サインアップユーザー',
    organisation: '組織',
    usage_report: '使用レポート',
    check_email: 'メールを確認してください',
    delete_schedule: 'スケジュールを削除',
    are_you_sure_delete_schedule:
      'このスケジュールを削除してもよろしいですか？',
    add_task: 'タスクを入力してください！',
    coaching_available: 'コーチング可能としてマーク',
    message_booking_coaching:
      'この時間枠はユーザーによってコーチングのために予約されています。',
    task_day: 'タスク日',
    created_task_day: 'この日にタスクを作成しました。',
    event_day: 'イベント日',
    has_booked_coaching: 'この日にコーチングが予約されています。',
    active_day: 'アクティブな日',
    selectable_time_slots: '右側の選択可能な時間枠はこの日にアクティブです。',
    compare_last_month: '前月との比較',
    uploading_file: 'ファイルをアップロード中',
    attach_file_course: 'このコースに添付されました。',
    fetch_request: 'リクエストを取得中',
    finilize_upload: 'アップロードを完了中',
    scorm_scanned:
      'お待ちください...アップロードされたSCORM ZIPがスキャン中です。',
    scan_status: 'スキャン状況:',
    scan_completed: 'スキャン完了。ファイルは',
    scan_progress: 'スキャン中...',
    check_scorm: 'SCORMファイル形式を確認中...お待ちください...',
    file_check_success: 'ファイル確認成功',
    file_check_progress: 'ファイル確認中...',
    scorm_not_upload:
      'アップロードされたファイルはSCORM 1.2標準ではありません。再度アップロードしてください。',
    select_question: '回答オプション（正しい答えを1つ選択）',
    select_answer: '回答オプションを選択してください！',
    check_option_one: 'オプション1を入力してください！',
    check_option_two: 'オプション2を入力してください！',
    check_option_three: 'オプション3を入力してください！',
    check_option_four: 'オプション4を入力してください！',
    question_image: '質問画像',
    select_question_image: '質問画像を選択してください！',
    ans_image: '回答画像',
    upload_image_question: '回答画像をアップロード',
    select_image_answer: '回答画像を選択してください！',
    save_question: '質問を保存',
    do_you_leave: '終了してもよろしいですか？',
    loose_all_progress: 'すべての進行状況が失われます。',
    welcome: 'ようこそ',
    team_knowledge_quest: 'チームナレッジクエスト',
    your_score: 'あなたのスコア',
    start_playing: 'プレイを開始',
    share_sphere_complete: 'ShareSphere完了',
    final_score: '最終スコア',
    play_next: '次をプレイ',
    you_donot_access_event: 'このイベントへのアクセス権がありません。',
    ai_content_generated: 'このトピックのコンテンツが生成されました。',
    ai_popup_confirm_content: 'コンテンツ生成を確認',
    limit_transcribe_text:
      '残りの文字起こし時間: <0>{{ transcribe_limit }}</0> 分 <1/><2/> <3>。文字起こしの制限を変更するには、こちらまでご連絡ください </3> <4>admin@sharelook.com</4>。',
    you_donot_access_event: 'このイベントへのアクセス権がありません。',
    ai_course_title_training: 'リーダーシップトレーニングコース',
    ai_course_object: 'デジタル時代のリーダーシップナビゲーション',
    create_ai_video: 'AIビデオを作成',
    generate: '生成',
    video_generate_process:
      'ビデオの生成には時間がかかる場合があります。完了次第、メールでお知らせします。',
    stripe_account_connect:
      'あなたのStripeアカウントは非アクティブです。続行するには接続または有効化してください。',
    ai_creator: 'AIクリエイター',
    check_video_status: 'ビデオ生成状況を確認しています...',
    video_on_queue: 'ビデオの生成がキューに入っています。',
    video_fail_generation:
      '申し訳ありませんが、ビデオの生成に失敗しました。もう一度お試しください。',
    video_currently_generated: 'このビデオは現在生成中です。',
    checking_status: '状態を確認中',
    check_status: '状態を確認',
    browser_does_not_support_audio:
      'お使いのブラウザはオーディオタグに対応していません。',
    existing_edit_scenario:
      '既存のシナリオを編集しますか、それとも新しいシナリオを作成しますか？新しいシナリオを作成すると、古いシナリオは失われます。',
    generate_scenario: 'シナリオを生成',
    layout: 'レイアウト',
    confirm_change: '変更を確認',
    generated_ai_creation_message:
      'AI生成されたテキスト要素のみが保持されます。他のすべての要素はページから削除されますのでご注意ください。',
    generate_story: 'ストーリーを生成',
    save_original_content: '元のコンテンツを保存:',
    story_added_specified_position:
      'レッスン内のストーリーの位置。指定された位置にブロックとしてストーリーが追加されます。',
    position_of_story: 'ストーリーの位置',
    start_the_lesson: 'レッスンの開始',
    end_the_lesson: 'レッスンの終了',
    add_story_pages: 'ストーリーをページに追加',
    browser_does_not_support:
      'お使いのブラウザはオーディオ要素に対応していません。',
    no_video_available: '利用可能なビデオがありません。',
    no_podcast_available: '利用可能なポッドキャストがありません。',
    no_item_baskets: 'カートにアイテムがありません。',
    ai_course_object: 'デジタル時代のリーダーシップナビゲーション'
  },
  v2: {
    n_data: 'データなし',
    change: '変更',
    remove: '削除',
    auto_background: '自動背景',
    create_new_course_org: '組織のために新しいコースを作成します。',
    create_new_course_marketplace:
      'マーケットプレイスのために新しいコースを作成します。',
    create_new_course_both:
      '組織とマーケットプレイスの両方のために新しいコースを作成します。',
    ok: 'OK',
    page_bg: 'ページ背景',
    lesson_cover: 'レッスンのカバーピクチャー',
    create_skill_journey: 'スキルジャーニーを作成',
    Metamaze: 'メタメイズ',
    events: 'イベント',
    scroms: 'SCORM',
    min_score_pass: '合格するための最低スコア',
    no_scorms_available: '利用可能なSCORMはありません。',
    no_events_available: '利用可能なイベントはありません。',
    no_courses_available: '利用可能なコースはありません。',
    no_courses_baskets: 'カゴにコースはありません。',
    no_mazes_baskets: 'カゴにメイズはありません。',
    no_scroms_baskets: 'カゴにSCORMはありません。',
    no_events_baskets: 'カゴにイベントはありません。',
    sorry: '申し訳ありません！',
    option_1: 'オプション1',
    option_2: 'オプション2',
    enter_number_words: '最大単語数を入力してください。',
    summarize: '要約する',
    answer: '回答',
    hold_tight_one_minute:
      'しばらくお待ちください！準備中です。最大で1分かかる場合があります。',
    enter_question: '質問を入力してください。',
    enter_relevant_documents: '関連する文書の数を入力してください。',
    please_input_relevant_documents: '関連する文書の数を入力してください！',
    please_wait_loading_results: '結果の読み込みをお待ちください...',
    proceed_to_add_voice: '音声の追加に進む',
    results: '結果',
    no_result_found_try_asking_questions:
      '結果が見つかりません。もっと質問してみてください。',
    eg: '例、',
    what_make_sales_manager: '何が私を営業マネージャーにできるか？',
    please_select_lang: '言語を選択してください！',
    search: '検索',
    please_copy_desired_content:
      '左のボックスから右のボックスへ希望の内容をコピーしてください。',
    rating_req: '評価は必須項目です。',
    review_req: 'レビューは必須項目です。',
    rating_review_req: '評価とレビューの両方を提供する必要があります。',
    how_rate_this: 'これをどう評価しますか？',
    amazing_above_expectations: '素晴らしい！期待以上です！',
    certificates: '証明書',
    you_no_certificates: '現在利用可能な証明書はありません。',
    please_add_review:
      '評価と一緒にレビューをお願いします。ありがとうございます！',
    post: '投稿',
    rate: '評価する',
    avg_rating: '平均評価',
    no_review_found: 'レビューが見つかりません',
    are_sure_to_disale_zoom_integration:
      'Zoom連携を無効にしてもよろしいですか？',
    badges: 'バッジ',
    you_no_badge_available: '現在利用可能なバッジはありません。',
    download_certificate: '証明書をダウンロード',
    loading: '読み込み中...',
    no_file_attached: '添付ファイルなし',
    you_do_not_have_any_notes: 'メモがありません。',
    question: '質問',
    score: 'スコア',
    alert_score_message: 'スコアが送信されました。',
    alert_question_message: 'まだ質問が追加されていません。',
    button_submit: '送信',
    button_allScores: 'すべてのスコアが送信されました。',
    record_wait: '録音を開始しています。少々お待ちください...',
    buttonSubmit_warning: '送信前にすべてのスコアを入力してください。',
    upload_ar_assets: 'ARアセットをアップロード',
    edit_ar_assets: 'ARアセットを編集',
    edit_maze_assets: 'MetaMazeアセットを編集',
    upload_assets: 'アセットをアップロード',
    upload_maze_assets: 'MetaMazeアセットをアップロード',
    trigger_title: 'トリガータイトル',
    model_title: 'モデルタイトル',
    trigger_description: 'トリガーの説明',
    model_description: 'モデルの説明',
    please_type_target_description: 'ターゲットの説明を入力してください。',
    please_type_model_description: 'モデルの説明を入力してください。',
    trigger_image: 'トリガー画像*',
    model_image: 'モデル画像*',
    upload_trigger_image: 'トリガー画像をアップロード',
    upload_model_image: 'モデル画像をアップロード',
    drag_n_drop: 'ドラッグ＆ドロップ',
    file_size_should_not_exceed:
      '(画像ファイル（JPEG）は512KB以下でなければなりません)',
    zip_size_should_not_exceed: '(Zipファイルは60MB以下でなければなりません)',
    ar_content: 'ARコンテンツ*',
    model_content: '3Dモデル*',
    upload_3d_zip: 'ZIP／ビデオをアップロード',
    upload_3d_maze_zip: 'ZIPをアップロード',
    audio_content: 'オーディオコンテンツ',
    _mp3: '(.mp3)',
    content_attached: 'Zipが添付されました。',
    video_attached: 'ビデオが添付されました。',
    audio_attached: 'オーディオが添付されました。',
    enter_trigger_image_title: 'トリガー画像のタイトルを入力してください。',
    enter_model_title: 'MetaMazeモデルのタイトルを入力してください。',
    ar_preview_image: 'ARプレビュー画像',
    upload_preview_image: 'プレビュー画像をアップロード',
    upload_audio: 'オーディオをアップロード',
    creating___: '作成中…',
    updating___: '更新中…',
    create: '作成',
    update: '更新',
    ar_assets: '3D画像',
    _3d_files_mp4: '(Zip .obj、.fbx、または.mp4ビデオ)',
    _3d_files_mp4_ar: '(Zip .obj、.fbx)',
    maze_3d_files_mp4: '(Zip .obj、.fbx)',
    _jpg_files: '.jpgファイルのみ対応',
    persons_have_submitted_their_scores: 'ユーザーがスコアを提出しました。',
    no_questions_added_till_now: 'まだ質問が追加されていません。',
    submit: '送信',
    all_scores_submitted: 'すべてのスコアが提出されました。',
    recording_is_starting: '録画を開始しています。しばらくお待ちください…',
    please_input_scores_before_submitting:
      '送信する前にすべてのスコアを入力してください。',
    end_for_all: '全員の終了',
    full_screen: 'フルスクリーン',
    breakout_room: 'ブレイクアウトルーム',
    send_invitations: '招待を送信',
    add_participants: '参加者を追加',
    create_breakout_room: 'ブレイクアウトルームを作成',
    connecting: '接続中…',
    currently_broadcaster_unavailable: '現在、配信者は利用できません。',
    how_many_breakout_room_to_create:
      'いくつのブレイクアウトルームを作成しますか？',
    create_upto_three_breakout_rooms:
      '*最大3つのブレイクアウトルームを作成できます',
    allow: '許可',
    additional: '追加',
    attachment: '添付ファイル',
    no_description_available: '説明がありません。',
    people: '人々',
    waiting: '待機中',
    hand_raising_users: '手を挙げているユーザー',
    invite: '招待',
    create_room: 'ルームを作成',
    create_live_event: 'ライブイベントを作成',
    support_upto_fivethousand_participants: '最大5,000人の参加者をサポート',
    support_upto_ten_participants: '最大10人のビデオ参加者をサポート',
    support_upto_twohundred_participants: '最大200人のイベント参加者をサポート',
    supprt_upto_five_participants: '最大5人のビデオ参加者をサポート',
    support_upto_twentyfive_participants: '最大25人のビデオ参加者をサポート',
    two_live_video_participants: 'ビデオ参加者が2名います（ホストと参加者）',
    you_can_have_upto_five_examinees: '最大5名の受験者を設定できます。',
    you_can_have_upto_twentyfive_participants:
      '最大25名の参加者を設定できます。',
    you_can_have_upto_five_participants: '最大5名の参加者を設定できます。',
    you_can_have_upto_ten_participants: '最大10名の参加者を設定できます。',
    select_hosts_email: 'ホストのメールアドレスを選択',
    send_invite_email: '招待メールを送信',
    do_not_send_invite_email: '招待メールを送らない',
    error: 'エラー',
    max_twentyfive_users_allowed: '最大25名のユーザーを選択できます',
    max_five_users_allowed: '最大5名のユーザーを選択できます',
    max_ten_users_allowed: '最大10名のユーザーを選択できます',
    no_user_found: 'ユーザーが見つかりません',
    transcribe_to: '文字起こし先',
    integrate_zoom_to_start_meeting:
      'Zoomを統合してミーティングを開始してください。',
    zoom_is_not_integrated: 'Zoomが統合されていません。',
    delete_poll: 'アンケートを削除',
    add_poll: 'アンケートを追加',
    live_now: 'ライブ中！',
    average_rating: '平均評価',
    review: 'レビュー',
    time_spent: '経過時間',
    total: '合計',
    mins: '分',
    no_data: 'データがありません。',
    total_score: '合計スコア',
    pass_score: '合格スコア',
    point: 'ポイント',
    wrong: '誤り',
    response: '応答',
    submitted: '送信済み',
    average: '平均',
    total_play: '再生回数合計',
    view_graph: 'グラフを表示',
    time_spent_mins: '経過時間（分）',
    play: '再生',
    ideal_path: '理想的なパス',
    user_incorrect_path: 'ユーザーの誤ったパス',
    ideal_path_taken: 'ユーザーがたどった理想的なパス',
    scenario: 'シナリオ',
    option: 'オプション',
    spend: '消費',
    average_spending_time: '平均使用時間',
    activity_overview: 'アクティビティ概要',
    live_event: 'ライブイベント',
    live_assessment: 'ライブ評価',
    report_download: 'レポートをダウンロード',
    all_workshops: 'すべてのワークショップ',
    overview_average_activity: '平均アクティビティ概要',
    overview_workshop_graph: 'ワークショップグラフ',
    mazes: '迷路',
    correct_feedback: '正しいフィードバック',
    incorrect_feedback: '誤ったフィードバック',
    checkin_checkout: 'チェックイン・チェックアウト',
    minutes: '分',
    incorrect_path: '誤ったパス',
    answer_not_available: '回答がありません',
    views: 'ビュー',
    item: '項目',
    questions: '質問',
    total_points: '総ポイント',
    total_attempts: '総試行回数',
    created_date: '作成日',
    host_name: 'ホスト名',
    host_section: 'ホストセクション',
    choose_products: '製品を選択',
    add_to_basket: 'バスケットに追加',
    basket: 'バスケット',
    times: '回数',
    scorms: 'SCORMs',
    skill_journey_overview: 'スキルジャーニー概要',
    how_to_use: '使い方',
    live_broadcast_description:
      '使いやすいコース構築ツールにライブ配信を統合しました',
    live_broadcast_subdescription:
      'ShareLookの特許取得済みライブ配信システムで、エンゲージメントを高めて学習を自動化し、知識共有を最大化できます。',
    disclaimer: `私のスキルジャーニーには以下が含まれていないことを保証します:
- 第三者の権利を侵害する内容
- 違法なコンテンツ（中傷、わいせつ、暴力、差別）
- 個人攻撃
- 他者になりすます行為
- 無断で個人情報を記録する行為
- 商用勧誘やスパム`,
    price: '価格',
    video_link: 'ビデオリンク',
    category: 'カテゴリ',
    objectives: '目的',
    marketplace_description: 'マーケットプレイス説明',
    live_discussion: 'ライブディスカッション',
    poll: 'アンケート',
    hide_grid: 'グリッドを非表示',
    show_grid: 'グリッドを表示',
    stop_screen_share: '画面共有を停止',
    screen_share: '画面共有',
    mute: 'ミュート',
    unmute: 'ミュート解除',
    raise_hand: '手を挙げる',
    waiting__: '待機中…',
    audio_active: 'オーディオ有効'
  },

  general: {
    save: '保存',
    autosaved: '自動保存',
    back_to: 'に戻る',
    by: 'で',
    chat: 'チャット',
    completed: '完了',
    canceled: 'キャンセル',
    component: 'コンポーネント',
    confirm: '確認',
    course: 'コース',
    skill: 'スキルジャーニー',
    maze: 'メタメイズ',
    channel: 'チャンネル',
    podcast: 'ポッドキャスト',

    date: '日付',
    details: '詳細',
    empty: 'データなし',
    enrolled: '登録',
    free: '無料',
    graph: 'グラフ',
    loading: '読み込み...',
    lesson: 'レッスン',
    lessons: 'レッスン',
    live_assessment: 'ライブアセスメント',
    live_event: 'ライブイベント',
    no: 'ない',
    of: 'の',
    or: 'か',
    organization: '組織',
    page: 'ページ',
    pages: 'ページ',
    personal: '個人',
    poll: '投票',
    rating: 'レイティング',
    reset: 'リセット',
    signin: 'サインイン',
    signup: 'サインアップ',
    soon: 'もうすぐ',
    type: '型',
    uploading: 'アップロード...',
    yes: 'はい',
    something_went_wrong: '何かがうまくいかなかった!',
    view_all: 'すべてを見る',
    upload_successful: 'アップロードに成功しました',
    upload_successful_message:
      'Excel ドキュメントは正常にアップロードされ、現在処理中です。これには時間がかかる場合があります。',
    check_email_upload_successful: `アップロードしたユーザー一覧の <a0>Report</0> に電子メールを確認してください.`,
    is_private: 'プライベート'
  },

  account: {
    title: 'アカウント',
    subtitle: '設定とアカウント情報を管理します。',
    saved: 'アカウントが正常に変更されました'
  },

  assessments: {
    title: '評価',
    subtitle: '評価の作成',
    finished: '評価は終了しました',
    countdown: 'ライブアセスメントは放送されます',
    create: '評価の作成',
    list_title: 'あなたの評価',
    delete_warning: 'このアイテムを削除しますか?',
    details_title: '評価の詳細を追加する',
    details_subtitle:
      'アセスメントに名前を付け、視聴者に何を学ぶべきかを伝えます。',
    disclaimer: `私は、私の記録された評価が行わないことを保証します。
    - 第三者の権利を侵害する
    - 中傷、わいせつ、わいせつ、みだら、暴力、虐待、侮辱、脅迫、差別的なコンテンツを含む違法性を含む、アスタリスクを装った
    - 他の人に対する個人的な攻撃を含む
    - 他の参加者、公人や有名人のなりすましを含む
    - 当該個人の同意なしに個人に関する記録または個人情報を含み、世界のどの部分でもデータ保護規制に違反することはありません
    - 商業的な勧誘または'スパム'の任意のフォームを含む`,
    assessment_details: '評価の詳細',
    assessment_settings: '評価設定'
  },

  buildersettings: {
    title: '公開設定',
    subtitle: 'イベントを表示して操作できるイベントに設定を追加する'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: '追加',
    add_page: 'ページの追加',
    add_lesson: 'レッスンを追加する',
    add_answer: '新しい回答を追加する',
    add_group: 'グループの追加',
    add_organization: '組織の追加',
    add_question: '質問を追加する',
    add_quiz: 'クイズの追加',
    add_users: 'ユーザーの追加',
    back: '戻る',
    back_to_course: 'コース概要に戻る',
    back_to_lesson: 'レッスンの概要に戻る',
    back_to_media: 'メディアライブラリに戻る',
    back_to_details: '詳細に戻る',
    cancel: 'キャンセル',
    clear: 'クリア',
    close: '閉じる',
    clone: 'クローン',
    close_lesson: 'クローズレッスン',
    clone_course: 'クローンコース',
    confirm: '確認',
    create: ' Create',
    download: 'ダウンロード',
    download_mass_user_tamplate: 'テンプレートをダウンロード',
    add_mass_users: '一括ユーザーを追加',
    upload_excel_list: 'Excel リストのアップロード',
    delete: 'メディアの削除',
    edit: '編集',
    edit_course: 'コースの編集',
    enroll: '登録',
    finish: '完了',
    upload_image: '画像のアップロード',
    upload_image_video: '画像や動画をアップロードする',
    select_media_library: 'メディアライブラリを選択',
    make_public: '公開',
    make_private: 'プライベートにする',
    make_org: '組織を作る',
    media: 'メディアライブラリ',
    my_theme: '私のテーマ',
    next: '次に',
    next_lesson: '次のレッスン',
    next_step: '次のステップ',
    previous_step: '前のステップ',
    publish: '公開',
    publish_assessment: '評価を公開する',
    publish_course: 'コースを公開する',
    publish_event: 'イベントを公開する',
    reset: 'リセット',
    reset_elements: '要素をリセット',
    save: '保存',
    creating: '作成...',
    updating: '更新...',
    saved: '保存',
    save_for_later: '後で保存',
    save_settings: '設定を保存',
    select_files: 'ファイルを選択',
    select_theme: 'テーマを選択してください',
    start_lesson: 'レッスンを開始',
    update: '更新',
    upload: 'アップロード',
    upload_audio: 'オーディオのアップロード',
    upload_photo: 'プロフィール写真をアップロードする',
    upload_video: '動画のアップロード',
    enrolled: '登録',
    unenroll: '登録解除',
    from_library: 'メディアライブラリ',
    remove: '削除',
    removed: '取除か',
    start_broadcast: 'ブロードキャストの開始',
    end_broadcast: 'エンドブロードキャスト',
    camera: 'カメラ',
    screen: '画面',
    screen_with_camera: 'カメラ付きスクリーン',
    insert: '挿入',

    inserting: '挿入'
  },

  card: {
    quick_add: 'クイック追加',
    add: '追加',
    clone: 'クローン',
    completed: 'レッスンが完了しました'
  },

  course: {
    upcoming_course: '今後のコース',
    unPublishEvent: '公開解除イベント',
    unPublishAssessment: '未公開評価',
    pastCourse: 'トレーニングコース',
    upcoming: '今後のライブイベント',
    pastEvent: '過去のライブイベント',
    pastAssessment: '過去のライブアセスメント',
    upcomingAssessment: '今後のライブアセスメント',
    created: '作成日:',
    assignees: '譲受人',
    organisations: ' {{ 組織 }組織、<2> {{ユーザー }} ユーザー</2>',
    event_date: 'ライブイベント日 <1> {{ 日付 }}',
    delete_warning: '削除してもよ思いますか?',
    clonning_no_lesson:
      'このコースを複製するには、少なくとも1つのレッスンを追加してください。',
    clone_warning: 'クローンを作成しますか?',
    clone_success: 'クローニングプロセス中',
    disclaimer: `私は私のコースがしないことを保証します:
    - 第三者の権利を侵害する
    - 中傷、わいせつ、わいせつ、みだら、暴力、虐待、侮辱、脅迫、差別的なコンテンツを含む違法性を含む、アスタリスクを装った
    - 他の人に対する個人的な攻撃を含む
    - 他の参加者、公人や有名人のなりすましを含む
    - 当該個人の同意を得ることなく、いかなる個人に対しても個人情報を含め、世界のどの国のデータ保護規制にも違反しない
    - 商業勧誘または'スパム'の任意のフォームを含みます`
  },

  coursecreate: {
    dropzone_text: 'メディアの挿入',
    sidebar_text: '3/> レッスンのテーマを選択してください。',
    delete_warning: 'このレッスンを削除しますか?'
  },

  coursepage: {
    quizview_loading: '答えをチェックしています。お待ちください...',
    quizview_answer: 'あなたの答え'
  },

  coursequiz: {
    title: 'すべてのレッスンのクイズ'
  },

  dashboard: {
    tooltip_title: 'このビデオを二度と表示しない',
    page_title: 'あなたのコース統計',
    page_subtitle: '作成したコースのステータス',
    profile_add_info: `プロファイルを完了するには、<a0>{{{未完了のテキスト}}</1> を追加します。`,
    profile_build:
      'あなたのプロフィールを構築する<1>ここで</1>、あなたの興味とスキルをお知らせください。',
    profile_title: 'プロファイルの強さ',
    more_details: '詳細'
  },

  errors: {
    answer: '答えを入力してください',
    answer_correct: '正しい答えを選ぶ',
    code: 'コードを入力してください',
    criterion: '入力基準',
    duration: '期間が必要です',
    element: '入力要素',
    email: 'メールを入力してください',
    email_invalid: '入力は有効な電子メールではありません',
    feedback_correct: 'フィードバックを正しく入力してください',
    feedback_incorrect: '入力フィードバックが正しくありません',
    host: 'イベントホストを入力してください',
    host_assessment: '評価ホストを入力してください',
    image: '画像をアップロードしてください',
    location: 'あなたの場所を入力してください',
    live_location: '放送場所を選択してください',
    limit: 'ライブストリーミング分を入力してください',
    min_3char: '3 文字以上',
    number: '正の数を入力してください。',
    host_email_require: `ホストのメールが必要.`,
    attendee_email_require: '出席者のメールが必要です。',
    name: '名前を入力してください',
    not_found_course: 'コースが見つかりません',
    not_found_event: 'イベントが見つかりません',
    not_found_assessment: '評価が見つかりません',
    password: 'パスワードを入力してください',
    password_digit: '1 桁以上',
    password_short: 'パスワードが短すぎる、最小 10 文字',
    password_special: '少なくとも 1 つの特殊文字',
    password_uppercase: '大文字を少なくとも 1 つ',
    password_lowercase: '少なくとも 1 つの小文字',
    phone: 'お使いの携帯電話を入力してください',
    phone_invalid: '電話番号が無効です',
    position: 'あなたの位置を入力してください',
    question: '質問を入力してください',
    start_date: '開始日と時刻が必要です',
    tag: 'タグを選択してください',
    topics: '少なくとも 1 つのトピックを選択してください。,',
    live_topics: 'トピックを追加してください',
    title: 'タイトルを入力してください',
    title_assessment: '評価タイトルを入力してください',
    title_course: 'コースタイトルを入力してください',
    title_empty: 'タイトルは空にできません',
    title_event: 'イベントタイトルを入力してください',
    title_lesson: 'レッスンタイトルを入力してください',
    title_quiz: 'クイズ名を入力してください',
    username: 'ユーザー名を入力してください',
    upload_error: 'エラー - ファイルに互換性がありません!',
    upload_more_than_10: '一度にアップロードできるファイルは最大 10 個です。',
    topics_max: '最大で3つのトピックを追加してください。',
    upload_excel: '正しいファイルをアップロードしたことを確認してください。',
    title_excel: 'テンプレートのアップロード中にエラーが発生しました:',
    file_size_exceed: 'ファイル サイズを超えています',
    subtitle_excel:
      '提供されているテンプレートを使用し、列が正しく入力されていることを確認してください。',
    select_broadcast_option:
      'このイベントをブロードキャストするオプションを選択してください',
    multi_hosts_number_error:
      'いいえ。プレゼンターの数は、イベントに指定された値を超えることはできません。',
    conference_people_number_error: `いいえ。の出席者は、イベントに指定された範囲を超えることはできません。`,
    select_max_host: ' イベントの出席者を少なくとも 1 人選択してください。',
    select_max_conference:
      ' イベントの出席者を少なくとも 1 人選択してください。',
    stream_stop_error: 'ストリーミングが予期せず停止しました!',
    unsecure_context:
      '致命的なエラー: ブラウザは、安全でないコンテキストのためにカメラとマイクにアクセスできません。SSLをインストールして、https経由でアクセスしてください',
    ws_not_supported:
      '致命的なエラー: ウェブソケットはこのブラウザではサポートされていません',
    no_org: '続行するには、少なくとも 1 つの組織を選択してください。',
    no_org_group:
      '続行するには、少なくとも 1 つの組織グループを選択してください。',
    waiting_to_join: '誰かが参加するのを待っています！'
  },

  events: {
    title: 'ライブイベントの詳細を追加',
    change_host: 'ホストの変更',
    finished: 'イベントは終了しました',
    countdown: 'ライブイベントはで放送されます',
    subtitle: 'ライブイベントに名前を付け、視聴者に何を学ぶべきかを伝えます。',
    poll_disabled: 'このイベントではポーリングは利用できません',
    disclaimer: `私は私の記録されたイベントがしないことを保証します:
    - 第三者の権利を侵害する
    - 中傷、わいせつ、わいせつ、みだら、暴力、虐待、侮辱、脅迫、差別的なコンテンツを含む違法性を含む、アスタリスクを装った
    - 他の人に対する個人的な攻撃を含む
    - 他の参加者、公人や有名人のなりすましを含む
    - 当該個人の同意なしに個人に関する記録または個人情報を含み、世界のどの部分でもデータ保護規制に違反することはありません
    - 商業勧誘または'スパム'の任意のフォームを含みます'`,
    prompt_message:
      'このページを離れるとイベントが終了します。このページから離れますか?',
    duration_exceed_message:
      'あなたの放送時間を超えると、アプリは放送を停止します。',
    before_schedule_message:
      '予定されたイベント時刻の前にブロードキャストを開始しようとしています。ブロードキャストを停止するとイベントが終了しますのでご注意ください。',
    browser_unsupportive_message:
      'お使いのブラウザーはスクリーン共有をサポートしていません。このリンクでサポートされているブラウザを見ることができます',
    cancel_switch_host_message:
      'ホストは使用できません。イベントはあなたの終わりから続きます。',
    coaching_prompt_message:
      'イベントが終了するまで、このページを離れることはできません。',
    event_modal_warn: 'このイベントを離れますか?',
    confirm_message: 'OK をクリックすると、イベントは終了します。',
    screen_share_denied: '画面の共有を拒否しました',
    media_not_found:
      'カメラまたはマイクが見つからないか、お使いのデバイスで許可されていません。',
    media_not_access:
      'カメラまたはマイクは、デバイスを読み取らない他のプロセスで使用されています',
    constraint_error:
      'ビデオとオーディオの制約に合ったデバイスが見つかりません。ビデオとオーディオの制約を変更することができます',
    media_access_denied: 'カメラとマイクにアクセスすることはできません.'
  },

  filters: {
    days7: '過去7日間',
    days15: '最後の15日間',
    days30: '過去30日間',
    days365: '過去365日間',
    date: '作成日',
    relevance: '関連性',
    popularity: '人気',
    name: '名前',
    group: 'グループ',
    Newest_to_Oldest: '最新から最も古い',
    Oldest_to_Newest: '最も古いものから最新の',
    A_Z: 'A to Z',
    Z_A: 'Z to A'
  },

  helpers: {
    password:
      'アカウントのセキュリティを確保するために、パスワードに少なくとも1つの小文字の番号が必要です。また、10 文字の最小長を持つ必要があります。',
    phone: 'お使いの携帯電話の国コードを含めてください。,例えば:+65',
    username:
      'ユーザー名は公開情報として扱われ、必要に応じて他のユーザーと共有されます。そのため、ユーザー名に個人情報を使用しないことをお勧めします。',
    public_description_normal: `<0></0/0/0> は保存されており、既定ではプライベートと見なされます。つまり、このコンテンツは自分だけが見ることができます。このコンテンツを発行するには、以下のオプションのいずれかを選択します。コースを公開すると、プラットフォームのすべてのユーザーが利用できるようになります。特定のユーザーオプションを使用すると、共有の外観 アカウントに関連付けられた電子メール アドレスを使用して、特定のユーザーとコースを共有できます。`,
    public_description_admin:
      'この <0></0/0/</0> は保存されており、既定ではプライベートと見なされます。つまり、このコンテンツは、あなた (およびコンテンツ作成者) だけが表示できます。このコンテンツを発行するには、以下のオプションのいずれかを選択します。コースを公開すると、組織外のユーザーを含め、プラットフォーム内のすべてのユーザーが利用できるようになります。組織に公開すると、組織内のすべてのユーザーが表示できるようになります。また、1 つ以上のグループに公開することもできます。 最後に、共有の外観 アカウントの電子メール アドレスを使用して、組織内外の特定のユーザーに公開するオプションがあります。'
  },

  labels: {
    add: '追加',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: '回答の種類',
    answers: '答え',
    back_to_quiz: 'クイズリストに戻る',
    back_to_question: '質問リストに戻る',
    chat: 'チャット',
    chat_available: 'このイベントではチャットは利用できません',
    chat_report: 'チャットレポート',
    choice_single: '単一の選択肢',
    choice_multiple: '複数の選択肢',
    choice_free: '"無料"の選択',
    choice_sorting: '"並べ替え"の選択',
    choice_matrix: '"マトリックスソート"の選択',
    clone_lesson_permission: 'クローンアクセス許可',
    code: 'コード',
    correct: '正しい',
    created: '作成日',
    clone_modal: 'クローンコース',
    cloning_course: 'クローニングコース...',
    cloning: 'クローニング。..',
    cloning_course_desc:
      'このプロセスにはしばらく時間がかかります。我慢してください',
    cloning_success: 'コース"</>"は正常にクローン化されています!',
    description: '説明',
    disclaimer: '免責事項',
    drop_file: 'ここにファイルをドロップする...',
    duration: '持続時間',
    edit: '編集',
    email: '電子メール',
    event: 'イベント',
    event_all: 'イベント ...',
    event_date: 'ライブイベント ローカル日時',
    event_this: 'このイベント',
    expire: '有効期限',
    expiry_date: '有効期限',
    forgot: 'パスワードを忘れた場合?',
    group: 'グループ',
    groups_list: 'グループのリスト',
    host: 'ホスト',
    id_annotation: '注釈 ID',
    id_quiz: 'クイズID',
    incorrect: '誤った',
    interests: '興味',
    invited: '招待',
    live_chat: 'ライブディスカッション',
    live_stream_limit: 'ライブストリーミングの分',
    contact_text:
      '毎月のライブストリーミング制限を変更するには、お問い合わせください',
    contact_admin:
      '<0>毎月のライブストリーミング制限を変更したい場合は、</0> </admin@共有の外観.com</0> までお問い合わせください。',
    limit_stream_text:
      'ライブストリーミング残り時間: <0>{{制限 }}</0> 分 <1/></2>毎月のライブストリーミング制限を変更するには、</3> </admin@共有の外観.com</4> までお問い合わせください。',
    location: '場所',
    lessons: 'レッスン',
    location_broadcast: 'ホスト サーバーの場所',
    location_broadcast_subtitle:
      '視聴覚の遅延を減らすために放送ホストの場所に最も近い場所を追加します。',
    media_manager: 'メディアマネージャー',
    minutes: '分',
    name: '名前',
    online_quiz: 'オンラインクイズ',
    organiser: '著者',
    organization: '組織',
    overall_emotion: '全体的な経験:',
    organizations_list: '組織一覧',
    password: 'パスワード',
    participants: '参加者',
    picture: '絵 (16:9)',
    phone: '電話',
    photo: '写真',
    poll: '投票 ',
    position: '位置',
    processing: '処理',
    privacy_settings: 'プライバシー設定',
    question: '質問',
    quiz_create: '新しいクイズの作成',
    quiz_name: 'クイズ名',
    quiz_update: '更新クイズ',
    select_organization: '組織を選択してください',
    settings: '設定',
    show: '表示',
    show_graph: 'グラフ結果を表示する',
    signin: 'サインイン',
    signup: 'サインアップ',
    sort_by: '並べ替え',
    start_date: '開始日',
    tags: `私はこれらの<1>利用規約に同意します。</a0>`,
    terms: '私はこれらの<1>利用規約に同意します。</a0>',
    title: 'タイトル',
    topics: 'トピック',
    topic: 'トピック',
    total_comments: '合計コメント',
    username: '名',
    users_list: 'ユーザーのリスト',
    users_emails: '特定のユーザーの電子メールを挿入する',
    description_specifiction_email:
      '複数の特定のユーザーと共有するには、1 行に 1 つの電子メール アドレスを入力してください。',
    message_specific_email: '指定ユーザーのメールを入力してください。',
    viewers: '視聴者',
    edit_course: '編集',
    edit_assessment: '編集',
    edit_event: '編集',
    delete_course: '削除',
    delete_event: '削除',
    delete_assessment: '削除',
    view_course: '見る',
    view_event: '見る',
    view_assessment: '見る',
    date_event: 'ライブイベントの日付',
    date_assessment: 'ライブ評価日',
    clone_of: 'クローン',
    clone_course: `このコースのクローンを作成して、オリジナルとは別に変更でき、すべてのレッスンとページが含まれます。`,
    make: '作る',
    available_to: '任意の 共有の外観 ユーザーが利用できる',
    uploaded_by: 'アップロードする人:',
    course: 'コース',
    assessment: '評価',
    user_not_exist: 'ユーザーが存在しません、 招待を送信しますか?',
    check_user: 'お知らせ',
    user_not_exist_in_org: 'ユーザーがこの組織に存在しません。',
    title_modal_stream: '組織のライブストリーム制限の変更',
    des_warning_stream: 'あなたは変わろうとしている',
    monthly_stream: '毎月のライブストリーミング制限:',
    min_per_month: '分/月',
    broadcast_label: '私はやりたい:',
    hosts_emails: `特定のホストの電子メールを挿入します。`,
    attendee_emails: `特定の出席者の電子メールを挿入する`,
    description_host_specifiction_email:
      '1 行につき 1 つの電子メール アドレスを入力してください。',
    presenter_label: 'プレゼンター',
    presenter_label_conference: '人々のNo.',
    event_privacy: '会議モード'
  },

  broadcastOptions: {
    stream_from_phone: '私の携帯電話でライブ放送',
    other_webrtc: '私のPCからのウェビナー',
    multihost: 'マイ PC からのマルチキャスト ウェビナー',
    peer2peer: 'コーチングセッション',
    conference: 'ライブカンファレンス'
  },

  lessoncreate: {
    title: 'レッスンの詳細を追加',
    subtitle: 'レッスンに名前を付け、聴衆に何を学ぶべきかを伝えます。',
    input_label_title: 'レッスンタイトル',
    input_label_topics: 'レッスントピック',
    input_label_description: 'レッスンの説明',
    delete_warning: 'このページを削除しますか?'
  },

  lessonoverview: {
    title: 'レッスンの追加',
    subtitle: '既存のレッスンを追加または新しいレッスンを作成する',
    new_lesson: '新しいレッスンを作成する',
    new_lesson_sub: 'ゼロから新しいレッスンを作成!',
    existing_lesson: '既存のレッスンを選択してください',
    existing_lesson_sub:
      '既存のレッスンにリンクすると、このレッスンに加えた変更は、他のコースでもこのレッスンに影響を与えます。',
    clone_lesson: '既存のレッスンを複製',
    clone_lesson_sub:
      'このコースのレッスンを独自にコピーすると、このレッスンに加えた変更は元のレッスンには影響しません。',
    clone_lesson_modal_sub:
      'コースに追加するレッスンの下にあるクローンボタンをクリックしてください。'
  },

  management: {
    groups_title: 'グループの管理',
    delete_warning: 'よいですか?',
    organizations_title: '私の組織',
    organizations_subtitle: 'リストに組織を追加する',
    users_title: 'ユーザーの管理',
    users_position: 'シニアアカウントマネージャー',
    user_not_found: 'ユーザーが見つかりません',
    select_org: 'ユーザーを管理する組織を見つけて選択してください'
  },

  audio: {
    modal_title: 'オーディオの挿入',
    list_view: 'リストビュー',
    create_audio_modal_title: 'オーディオの作成',
    edit_audio_modal_title: 'オーディオの編集',
    public_audio_not_found: 'オーディオが見つかりません。',
    private_audio_not_found: 'まだオーディオをアップロードしていません',
    are_you_sure_to_delete: '削除してもよいですか?',
    type_something: '何かを入力してください',
    select_voice: '選択',
    file_name: 'ファイル名',
    description: '説明',
    topic: 'トピック',
    key_words_tag: 'キーワードタグ',
    mp3_audio: 'MP3オーディオ',
    created: '作成',
    duration: '期間',
    close: '閉じる'
  },

  image: {
    modal_title: 'イメージの挿入',
    image: '画像',
    pixel: 'ピクセル',
    dimension: 'ディメンション',
    public_image_not_found: '画像が見つかりません。',
    private_image_not_found: 'まだ画像をアップロードしていません'
  },

  annotation: {
    modal_title: 'アノテーション'
  },

  text: {
    modal_title: 'テキストエディタ'
  },

  video: {
    modal_title: 'ビデオの挿入',
    image: 'ビデオ',
    mp4_video: 'MP4ビデオ',
    public_video_not_found: 'ビデオが見つかりません。',
    private_video_not_found: 'まだ動画をアップロードしていません'
  },

  media: {
    title: 'メディアライブラリ',
    subtitle: 'あなたのファイルのライブラリ',
    modal_title: 'メディアのアップロード',
    delete_warning: '削除の確認',
    delete_message:
      '削除されたメディアは、使用されたページに引き続き表示されます。',
    dropzone_text: 'またはドラッグアンドドロップ',
    delete_success: 'メディアは正常に削除されました',
    upload_file: 'ファイルのアップロード',
    drag_drop: 'またはドラッグアンドドロップ',
    import_file: 'コンピュータからファイルをインポートする',
    no_media: 'まだメディアをアップロードしていません',
    media_type: 'メディアタイプ',
    video: 'ビデオ',
    image: 'イメージ',
    audio: 'オーディオ',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'メディアが見つかりません.',
    of: 'の',
    disclaimer: `私は私のメディアがしないことを保証します:
    - 第三者の権利を侵害する
    - 中傷、わいせつ、わいせつ、みだら、暴力、虐待、侮辱、脅迫、差別的なコンテンツを含む違法性を含む、アスタリスクを装った
  - 他の人に対する個人的な攻撃を含む
  - 他の参加者、公人や有名人のなりすましを含む
  - 当該個人の同意を得ることなく、いかなる個人に対しても個人情報を含め、世界のどの国のデータ保護規制にも違反しない
  - 商業勧誘または'スパム'の任意のフォームを含みます`,
    my_media: 'マイメディア',
    public_library: '公共図書館',
    organization_library: '組織図',
    upload_from_computer: 'コンピュータからアップロード',
    create: '作成',
    all: '全て',
    male: '男性',
    female: '女性',
    processing_audio: 'オーディオを処理しています',
    create_annotation: '注釈の作成',
    popup_over_lesson_text:
      'クリック後に、注釈がレッスンページにポップアップ表示されます',
    edit_detail: '詳細の編集',
    delete: '削除',
    go_create_audio: '音声を作成する',
    show_more_details: '詳細を表示',
    show_less_details: '詳細を表示する',
    drop_files: 'ドロップファイルとアップロードする場所',
    or: 'か',
    import_files: 'コンピュータからファイルをインポートする'
  },

  navigation: {
    account: 'アカウント',
    assessments: '評価',
    dashboard: 'ダッシュ ボード',
    groups: 'グループマネジメント',
    logout: 'ログアウト',
    organisations: '組織の',
    organizations_users: '組織とユーザー',
    reports: 'レポート',
    schedule: 'スケジュール',
    training: 'トレーニング',
    users: 'ユーザー',
    workshop: '私のワークショップ',
    nowLive: '放送'
  },

  onboarding: {
    step1_title: 'ステップ1:あなた自身について少し教えてください',
    step1_subtitle: 'あなたの名前は何ですか?ご出身は。あなたの役職は何ですか?',
    step2_title:
      'ステップ2:あなたが改善することができるいくつかのスキルを選択してください',
    step2_subtitle:
      '次に、より良い理解を得たいことを教えてください。おそらく、あなたはまだ拾っていない何か?新しい研究分野?あなたの愛する人は何をしますか?'
  },

  pagebuilder: {
    title: 'レッスンの作成',
    subtitle:
      '視聴者があなたから学ぶためにコンテンツを作成する時間、あなたは写真、ビデオ、インフォグラフィックをすることができます',
    select_layout: 'ページレイアウトを選択',
    template1: 'ブランク',
    template2: 'タイトルとサブタイトル',
    template3: 'タイトルとテキスト',
    template4: 'タイトル、メディア、テキスト',
    template5: 'タイトルとメディア',
    template6: 'タイトルとクイズ'
  },

  pageconstructor: {
    title: 'レッスンの作成とクローン作成',
    subtitle:
      '視聴者があなたから学ぶためにコンテンツを作成する時間、あなたは写真、ビデオやインフォグラフィックを追加することができます'
  },

  passwordreset: {
    success_coded:
      '入力したアドレスに確認コードを電子メールで送信しましたので、以下のフィールドにコードをコピーして新しいパスワードを設定してください。',
    success_changed:
      '新しいパスワードを設定しました。今すぐサインインできます。'
  },

  placeholders: {
    search: '検索',
    answer: '答え',
    chat: '何かを言う...',
    code: 'コード',
    criterion: '基準',
    date_event: '日付と時刻を選択',
    date_start: '開始日',
    date_expire: '有効期限',
    description: '説明',
    elements: '要素を並べ替える',
    email: '電子メール',
    feedback_correct: 'フィードバックが正しい',
    feedback_incorrect: 'フィードバックが正しくありません',
    host: 'ホスト',
    keywords: '検索キーワード',
    lesson_description: 'レッスンの説明',
    location: '場所',
    minutes: '分',
    name: '名前',
    organiser: '著者',
    organization: '組織',
    password: 'パスワード',
    phone: '電話',
    photo: '写真',
    picture: '画像',
    point: 'ポイント',
    position: '位置',
    question: '質問',
    quiz: 'クイズ名',
    search_course: 'コースで検索',
    search_media: '検索メディア',
    search_name: '名前で検索',
    search_title: 'タイトルで検索',
    search_training: '検索トレーニング',
    settings: '設定',
    tags: 'タグ',
    title: 'タイトル',
    topics: 'トピック',
    username: '名',
    keyword: 'キーワード',
    max_500_characters: '最大500文字',
    no_description: 'このファイルには説明がありません',
    no_keyword: 'このファイルにはキーワードがありません',
    no_topics: 'このファイルにはトピック セットがありません',
    feedback: 'メッセージ',
    contact: '私たちがどのように助けることができるか?'
  },

  publishsettings: {
    title: '公開設定',
    event_subtitle: 'イベントを表示して操作できるイベントに設定を追加する',
    assessment_subtitile: '評価に名前を付け、視聴者に何を学ぶべきかを伝える',
    course_subtitle: '設定をコースに追加し、コースを表示して操作できます。',
    disclaimer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis',
    dates_validation_error: '両方の日付を入力する必要があります。',
    course_dates_validation_error: 'このコースの開始日と有効期限を入力してください。',
    emails_validation_error: '電子メールリストが無効です。',
    specific_email_validation_error: '1つの電子メールのみが許可されます。',
    i_agree_to_these: '私はこれらに同意します',
    terms_and_conditions: '利用規約。',
    PublicDescription:
      '無料の独立ユーザー:(プライベートおよびパブリックオプション)あなたの[コース|]イベント|[評価]は保存されており、デフォルトでは非公開と見なされます。つまり、このコンテンツは自分だけが見ることができます。このコンテンツを公開するには、以下のコンテンツを公開するよう選択できます。つまり、このコースはプラットフォーム内のすべてのユーザーが利用できるようになります。',
    OrganisationsDescription:
      '組織ユーザー: (""Finish"""の代わりに""Finish""を使用して"発行""を使用し、他のユーザーと同じ発行ページに移動しますが、公開オプションはありません)。あなたの [コース|イベント|[評価]は保存され、プライベートです。つまり、組織内の管理者だけがそれを表示できます。管理者の権限が必要なため、ユーザーは自分でコンテンツを組織内に公開することはできません。管理者に連絡して、コンテンツを公開、組織全体、組織内の特定のグループ、または特定のユーザーに公開するよう依頼してください。',
    OrganisationGroupsDescription: `組織管理者: (組織内で作成されたコンテンツ: プライベート、パブリック、組織、グループ、特定のユーザー): この [コース|イベント|[評価]は保存されており、デフォルトでは非公開と見なされます。つまり、このコンテンツは、あなた (およびコンテンツ作成者) だけが表示できます。このコンテンツを発行するには、以下のオプションのいずれかを選択します。コースを公開すると、組織外のユーザーを含め、プラットフォーム内のすべてのユーザーが利用できるようになります。組織に公開すると、組織内のすべてのユーザーが表示できるようになります。また、1 つ以上のグループに公開することもできます。 最後に、共有の外観 アカウントの電子メール アドレスを使用して、組織内外の特定のユーザーに公開することもできます。`,
    SpecificUsersDescription:
      '有料の独立ユーザー:(プライベート、パブリック、特定のユーザー)あなたの[コース|]イベント|[評価]は保存されており、デフォルトでは非公開と見なされます。つまり、このコンテンツは自分だけが見ることができます。このコンテンツを発行するには、以下のオプションのいずれかを選択します。コースを公開すると、プラットフォームのすべてのユーザーが利用できるようになります。特定のユーザーオプションを使用すると、共有の外観アカウントに関連付けられたメールアドレスを使用して、特定のユーザーとコースを共有できます。'
  },

  quiz: {
    quiz_empty: 'まだクイズを作成していません',
    questions_empty: 'まだ質問を作成していません'
  },

  regions: {
    asia_pacific_australia: 'オーストラリア',
    asia_pacific_india: 'インド',
    asia_pacific_japan: '日本',
    asia_pacific_s_korea: '韓国',
    asia_pacific_singapore: 'シンガポール',
    asia_pacific_taiwan: '台湾',
    eu_belgium: 'ベルギー',
    eu_germany: 'ドイツ',
    eu_ireland: 'アイルランド',
    south_america_brazil: 'ブラジル',
    us_central_iowa: 'アイオワ',
    us_east_s_carolina: 'サウスカロライナ州',
    us_east_virginia: 'バージニア',
    us_west_california: 'カリフォルニア',
    us_west_oregon: 'オレゴン'
  },

  reports: {
    title: 'レポート',
    workshop_report: 'ワークショップレポート',
    user_report: 'ユーザー レポート',
    organization_workshop: '組織ワークショップ',
    course: 'コース',
    live_event: 'ライブイベント',
    workShop_graph: 'ワークショップグラフ',
    organization_account: `組織アカウント`,
    all: '全て',
    name: '名前',
    id_number: 'ID番号',
    email: '電子メール',
    search_user_report: '検索ユーザーレポート',
    participant: '参加者',
    participants: '参加者',
    host: 'ホスト',
    username: 'ユーザー名',
    event: 'イベント',
    quiz: 'クイズ',
    assessment: '評価',
    time: '時間',
    no_recent_activity: '最近の活動はありません',
    workshops: 'ワーク ショップ',
    courses: 'コース',
    live_events: 'ライブイベント',
    live_assessments: 'ライブアセスメント',
    quizzes: 'クイズ',
    overview: '概要',
    by: 'で',
    views: '表示モード',
    status: 'ステータス',
    poll: '投票',
    comment: 'コメント',
    comments: 'コメント',
    no_comments: 'コメントなし',
    no_polls: '投票なし',
    live_date: 'ライブデート',
    score: 'スコア',
    question: '質問',
    submit: '送信',
    recent_activity: '最近の活動',
    ago: '前',
    no_data_found: 'データが見つかりません',
    start_end_live: '開始/ライブ終了',
    join_leave_date: '参加/退会',
    watched_time: '視聴時間',
    complete: '完了',
    in_complete: '不完全',
    today: '今日',
    seven_days: '7日間',
    last_month: '先月',
    one_year: '1年',
    all_time: 'オールタイム',
    report: 'レポート',
    from_date: '開始日',
    to_date: '終了日まで',
    all_workshop: 'オールワークショップ',
    all_participants: 'すべての参加者',
    live_assessment: 'ライブアセスメント',
    users: 'ユーザー',
    download: 'ダウンロード',
    recent: '最近',
    WorkShop: 'ワーク ショップ',
    Activity: '活動',
    created_date: '作成日',
    lessons: 'レッスン',
    lesson: 'レッスン',
    completed: '完了',
    report_download: 'レポートダウンロード',
    this_month: '今月',
    search_course: '検索コース',
    participants_graph: '参加者グラフ',
    viewed: '表示',
    enrolled: '登録',
    description: '説明',
    topic: 'トピック',
    analytic: '分析',
    quiz_list: 'クイズリスト',
    select_one: '1つを選択',
    group_status: 'グループステータス',
    duration_min: '期間(分)',
    submit_poll: '投票の送信',
    download_events: 'ダウンロードイベント',
    search_event: '検索イベント',
    duration: '期間',
    total_participants: '参加者の合計',
    message: 'メッセージ',
    avg_message: '平均メッセージ',
    per_message: 'メッセージ/イベントの割合'
  },

  signup: {
    success_step1:
      'ご提供いの住所に確認コードを電子メールで送信しましたので、下記の欄にコードをコピーして登録を確認してください。',
    success_step2: 'ありがとう。登録が完了しました。',
    privacy:
      '私は共有の外観の<1>利用規約</1>と<3>プライバシーポリシーに同意します。</3>'
  },

  stream: {
    emotion_impressive: '印象的',
    emotion_unimpressive: '印象的ではない',
    message_not_started: 'もうすぐ',
    message_running: 'ライブ',
    message_processing:
      '現在、ライブ録音を再生用に処理しています。後でもう一度確認してビデオを表示し、評価とフィードバックを追加し続けてください'
  },

  tabs: {
    audience: '観客',
    course: 'コース概要',
    details: 'ライブイベントの詳細',
    description: '説明',
    host: 'ホスト',
    lesson: 'レッスンの概要',
    lessons: 'レッスン',
    overview: '概要',
    page: 'ページビルダー',
    publish: '公開',
    settings: '公開設定',
    total_views: '総表示',
    live_participates: 'ライブ参加者',
    live_chats: 'ライブチャット',
    live_quiz: 'ライブ投票',
    trainer_rating: 'トレーナー評価',
    trainer_times: 'トレーナータイムズ',
    courses_quizzes: 'コースクイズ',
    user_list: 'ユーザーリスト',
    discussion: '議論',
    notes: '私のノート'
  },

  topics: {
    SALES_TRAINING: 'セールストレーニング',
    NEGOTIATION_TRAINING: '交渉訓練',
    CROSS_CULTURAL_AWARENESS: '異文化意識',
    NETWORKING_SKILLS: 'ネットワーキングスキル',
    SOFTWARE_ARCHITECTURE: 'ソフトウェアアーキテクチャ',
    PROJECT_MANAGEMENT: 'プロジェクト管理',
    DIGITAL_TRANSFORMATION: 'デジタルトランスフォーメーション',
    IT_CONSULTING: 'ITコンサルティング',
    MANAGEMENT_CONSULTING: '経営コンサルティング',
    HR_CONSULTING: '人事コンサルティング',
    INTERNET_OF_THINGS: 'モノのインターネット(IoT)',
    CYBERSECURITY: 'サイバーセキュリティ',
    PRIVACY_AND_GDRP: 'プライバシーとGDPR '
  },

  training: {
    title: 'トレーニング',
    title_assessment: '評価',
    subtitle: 'コースとライブイベント',
    enrolled_title: '登録コースとライブイベント',
    enrolled_subtitle: '登録したコースとライブイベント',
    enrolled_message: '現在、コースやイベントに登録されていません。',
    past_live_event_title: '過去のライブイベント',
    past_live_event_subTitle: 'ライブイベントの終了',
    past_live_event: 'おすすめコースとライブイベント',
    recomended_title: 'おすすめコースとライブイベント',
    now_live_event_title: '今すぐライブ',
    now_live_event_subTitle: 'ライブイベントやまもなく開催されるイベント',
    now_live_event: '現在、ライブイベントはありません。',
    webinar_event_title: 'ウェビナーチャンネル',
    webinar_event_subTitle: '完成したウェビナー',
    webinar_event: '現在、ウェビナーはありません。',
    p2p_event_title: 'コーチングセッション',
    p2p_event_subTitle: 'コーチングセッション終了',
    p2p_event: '現在、コーチングセッションはありません。.',

    now_live_assessment_title: '今すぐライブ',
    now_live_assessment_subTitle: '生きているか、すぐに起きる評価',
    now_live_assessment_message: '現在、ライブアセスメントはありません。',

    upcoming_assessment_title: '今後のライブアセスメント',
    upcoming_assessment_subtitle: '今後のライブアセスメント',
    upcoming_assessment_message: '現在、今後のライブ評価はありません。',

    past_live_assessment_title: '過去のライブ評価',
    past_live_assessment_subTitle: '完成したライブ評価',
    past_live_assessment_message: '現在、過去のライブ評価はありません。',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle: `<a0></0/0></a0> に基づいてコースとライブイベントをキュレーションしました。`,
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: '検索トレーニング',
    search_assessment: '検索アセスメント',
    recomended_message: '現在、推奨されるコースやイベントはありません。'
  },

  warnings: {
    delete: '本当に?'
  },

  workshop: {
    title: '私のワークショップ',
    subtitle: 'コースを作成するか、あなた自身のライブイベントを主催する',
    new_course: '新しいコースを作成する',
    new_event: '新しいライブイベントを作成する',
    new_assessment: '新しいライブ評価を作成する',
    courses_title: '作成されたコースとライブイベント',
    courses_subtitle: '作成したコースを編集・公開し、ライブイベントを計画する',
    tags_course: 'コース',
    tags_live: 'ライブイベント',
    tags_assessment: 'ライブアセスメント'
  },

  help_center: {
    sidebar: {
      title: 'どのように私たちはあなたを助けることができますか?',
      back_to: 'ダッシュ ボード'
    },
    menu: {
      help_center: 'ヘルプセンター',
      whats_new: '新機能',
      feedback: 'フィードバック',
      feedback_title: 'フィードバックを送信して見た目を共有する',
      terms_and_conditions: '利用規約',
      privacy_policy: 'プライバシーポリシー',
      contact_us: 'お問い合わせ'
    },
    get_started: {
      title: '共有ルックを始める',
      description: {
        main: '私たちは、使いやすいコースビルダーにライブビデオを統合しました',
        tagline:
          '共有の外観の特許取得済みのライブ放送システムを使用すると、エンゲージメントを作成し、学習を自動化し、知識共有を最大化することができます。'
      }
    },
    whats_new: {
      title: '共有ルックを始める',
      description: {
        main:
          'ストーリーテリングスタイルの学習を作成すると、短時間で作成でき、それほど高価ではないことをご存知でしたか? 共有の外観コースビルダーとそれぞれの才能を組み合わせる必要があります。あなたは私たちに尋ねることができます "HOW',
        tagline: ''
      }
    },
    create_workshop: 'ワークショップの作成方法',
    create_course: 'コースの作成方法',
    create_user: 'ユーザーを作成する方法',
    create_group: 'グループの作成方法',
    create_webinar: 'ウェビナーの作成方法',
    create_live_event: 'ライブイベントの作成方法',
    create_live_assessment: 'ライブアセスメントの作成方法',
    create_live_on_mobile: 'モバイルでライブを作成する',
    personalize_profile: 'プロフィールをパーソナライズする',
    manage_group: 'グループの管理',
    report: 'レポート',
    add_annotations: '注釈/ポップアップを追加する方法',
    add_audio: 'オーディオを追加する方法',
    add_header_and_footer: 'ヘッダーとフッターの追加',
    add_image: '画像を追加する方法',
    add_quiz_content: 'クイズコンテンツの追加方法',
    add_text_content: 'テキストコンテンツを追加する方法',
    add_user: 'ユーザーを追加する方法',
    add_video: 'ビデオを追加する方法',
    clone_course: 'コースのクローン作成方法',
    find_live_broadcast: 'ライブ放送の見つけ方',
    contact_us: {
      title: 'お問い合わせ',
      subject_placeholder: '件名を入力します。*',
      content_placeholder: 'メッセージを入力する*',
      subject_required: '*件名が必要です',
      content_required: '*メッセージが必要です',
      submit: '送信',
      cancel: 'キャンセル',
      sent: '送信済み'
    },
    feedback: {
      title: 'フィードバックを送信して見た目を共有する',
      attach_title: 'ファイルを添付する',
      choose: 'ファイルを選択',
      detail: 'ファイルはサポート チームと共有されます',
      content_placeholder: 'メッセージを入力する*',
      content_required: '*メッセージが必要です',
      submit: '送信',
      cancel: 'キャンセル',
      sent: '送信'
    }
  },
  discussion: {
    join_discussion: 'ディスカッションに参加'
  },
  notes: {
    title: '私のノート',
    add_note: '新しいメモを追加する'
  }
}
